webpackJsonp([1],{

/***/ 105:
/***/ (function(module, exports) {

module.exports = {"renderURLInit":"?p_p_id=kehoachaction_WAR_TichHopGiaoThongportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage&p_p_col_id=column-1&p_p_col_count=1&p_p_resource_id=getURLInit","renderURLInit2":"?p_p_id=vma_WAR_TichHopGiaoThongportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage&p_p_col_id=column-1&p_p_col_count=1&p_p_resource_id=getURLInit","renderURLInit3":"?p_p_id=danhmucriengaction_WAR_TichHopGiaoThongportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage&p_p_col_id=column-1&p_p_col_count=1&p_p_resource_id=getURLInit","headersChiTietChuyenTuyenDichVu":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Chủ tàu/ đơn vị khai thác","align":"center","sortable":false,"id":"tugboatCompanyName","type":"text","display":"tugboatCompanyName","style":{"min-width":"21em","max-width":"21em"}},{"text":"Số biên lai","align":"center","sortable":false,"id":"documentaryCode","display":"documentaryCode","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Từ ngày","align":"center","sortable":false,"id":"fromDate","type":"time","display":"fromDate","style":{"min-width":"15em","max-width":"15em"}},{"text":"Đến ngày","align":"center","sortable":false,"id":"toDate","type":"time","display":"toDate","style":{"min-width":"15em","max-width":"15em"}},{"text":"Hành động","align":"center","sortable":false,"id":"action","type":"text","display":"action","style":{"min-width":"15em","max-width":"15em"}}],"headersBienLaiThanhToan":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Trạng thái","align":"center","sortable":false,"id":"paymentStatus","type":"text","display":"paymentStatus","style":{"min-width":"8em","max-width":"8em"}},{"text":"Đại lý/ Chủ tàu","align":"center","sortable":false,"id":"shipAgencyName","type":"text","display":"shipAgencyName","style":{"min-width":"11em","max-width":"11em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Công suất","align":"center","sortable":false,"id":"power","display":"power","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Số biên lai","align":"center","sortable":false,"id":"documentaryCode","display":"documentaryCode","type":"text","style":{"min-width":"7em","max-width":"7em"}},{"text":"Ngày biên lai","align":"center","sortable":false,"id":"documentaryIssued","display":"documentaryIssued","type":"time","style":{"min-width":"10em","max-width":"10em"}},{"text":"Tổng tiền (VND)","align":"center","sortable":false,"id":"vndTotalAmount","display":"vndTotalAmount","type":"text","style":{"min-width":"10em","max-width":"10em"}},{"text":"Tổng tiền (USD)","align":"center","sortable":false,"id":"usdTotalAmount","display":"usdTotalAmount","type":"text","style":{"min-width":"10em","max-width":"10em"}},{"text":"Phân loại","align":"center","sortable":false,"id":"paymentCategory","type":"text","display":"paymentCategory","style":{"min-width":"11em","max-width":"11em"}},{"text":"Hành động","align":"center","sortable":false,"id":"action","type":"action","display":"","style":{"min-width":"11em","max-width":"11em"}}],"headersTtVmaTran_Slip":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Chọn","align":"center","sortable":false,"id":"tick","display":"tick","type":"tick","items":"itemSelects","style":{"min-width":"4em","max-width":"4em"}},{"text":"Số biên lai","align":"center","sortable":false,"id":"sequenceNo","type":"text","display":"sequenceNo","style":{"min-width":"11em","max-width":"11em"}},{"text":"Ngày biên lai","align":"center","sortable":false,"id":"documentaryIssued","display":"documentaryIssued","type":"time","style":{"min-width":"15em","max-width":"15em"}},{"text":"Số tiền thanh toán","align":"center","sortable":false,"id":"paymentAmount","display":"paymentAmount","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Thiết lập phí","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Lượt","align":"center","sortable":false,"id":"noticeShipType","display":"noticeShipType","type":"text","style":{"min-width":"11.3em","max-width":"11.3em"}},{"text":"Người thanh toán","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"text","style":{"min-width":"15em","max-width":"15em"}}],"headersTtVmaTran_Conversion":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Loại và công dụng","align":"center","sortable":false,"id":"shipTypeMT","display":"shipTypeMTName","type":"select","items":"shipTypeMTItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Loại tàu","align":"center","sortable":false,"id":"shipTypeCode","type":"select","display":"shipTypeName","items":"shipTypeItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Tên công thức","align":"center","sortable":false,"id":"functionType","display":"functionName","type":"select","items":"functionItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Hệ số nhân","align":"center","sortable":false,"id":"conversionRate","display":"conversionRate","type":"text"},{"text":"Đơn vị","align":"center","sortable":false,"id":"conversionUnit","display":"conversionUnit","type":"select","items":"conversionUnitItems","style":{"min-width":"17.1em","max-width":"17.1em"}},{"text":"Thời gian cập nhật","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"time","style":{"min-width":"11.3em","max-width":"11.3em"}}],"headersTtVmaTran_Type":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Mã cảng vụ","align":"center","sortable":false,"id":"portofAuthority","display":"portofAuthority","type":"text","style":{"min-width":"6em","max-width":"6em"}},{"text":"Loại phí","align":"center","sortable":false,"id":"transactionTypeName","type":"text","display":"transactionTypeName","style":{"min-width":"29.5em","max-width":"29.5em"}},{"text":"Cấp độ","align":"center","sortable":false,"id":"transactionLevel","display":"transactionLevel","type":"select","items":"transactionLevelItems","style":{"min-width":"10em","max-width":"10em"}},{"text":"Loại tiền","align":"center","sortable":false,"id":"currencyCode","display":"currencyCode","type":"select","items":"currencyItems","style":{"min-width":"10em","max-width":"10em"}},{"text":"Tên viết tắt","align":"center","sortable":false,"id":"transactionTypeShortName","display":"transactionTypeShortName","type":"text","style":{"min-width":"19em","max-width":"19em"}},{"text":"Thời gian cập nhật","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"time","style":{"min-width":"14em","max-width":"14em"}}],"headersTtVmaTran_Function":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Mã cảng vụ","align":"center","sortable":false,"id":"portofAuthority","display":"portofAuthority","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Loại phí","align":"center","sortable":false,"id":"transactionTypeCode","type":"select","display":"transactionTypeName","items":"transactionTypeItems"},{"text":"Mã công thức","align":"center","sortable":false,"id":"functionName","display":"functionName","type":"text"},{"text":"Thiết lập phí","align":"center","sortable":false,"id":"makePayment","display":"makePayment","type":"select","items":"makePaymentItems"},{"text":"Lượt vào","align":"center","sortable":false,"id":"forArrival","display":"forArrival","type":"select","items":"forArrivalItems"},{"text":"Lượt rời","align":"center","sortable":false,"id":"forDeparture","display":"forDeparture","type":"text"},{"text":"Phân loại","align":"center","sortable":false,"id":"chargeType","display":"chargeType","type":"select","items":"chargeTypeItems"},{"text":"Ghi chú công thức","align":"center","sortable":false,"id":"functionNote","display":"functionNote","type":"text"},{"text":"Diễn giải","align":"center","sortable":false,"id":"transactionNote","display":"transactionNote","type":"text"},{"text":"Mức thu","align":"center","sortable":false,"id":"chargeRate","display":"chargeRate","type":"text"},{"text":"Ràng buộc <br> trọng tải","align":"center","sortable":false,"id":"chargeConditions","display":"chargeConditions","type":"text"},{"text":"Mức miễn giảm","align":"center","sortable":false,"id":"discountRate","display":"discountRate","type":"text"},{"text":"Điều kiện miễn giảm <br> mục đích chuyến tàu","align":"center","sortable":false,"id":"discountType1","display":"discountType1","type":"select","items":"discountTypeItems"},{"text":"Điều kiện miễn giảm <br> ràng buộc loại tàu","align":"center","sortable":false,"id":"discountType2","display":"discountType2","type":"select","items":"discountTypeItems"},{"text":"Điều kiện miễn giảm <br> ràng buộc số chuyến tháng","align":"center","sortable":false,"id":"discountType3","display":"discountType3","type":"select","items":"discountTypeItems"},{"text":"Điều kiện miễn giảm <br> ràng buộc số giờ neo","align":"center","sortable":false,"id":"discountType4","display":"discountType4","type":"select","items":"discountTypeItems"},{"text":"Điều kiện miễn giảm <br> ràng buộc khu vực","align":"center","sortable":false,"id":"discountType5","display":"discountType5","type":"select","items":"discountTypeItems"},{"text":"Áp dụng <br> ngày bắt đầu/ kết thúc","align":"center","sortable":false,"id":"applied","display":"applied","type":"select","items":"appliedItems"},{"text":"Áp dụng từ ngày","align":"center","sortable":false,"id":"appliedFrom","display":"appliedFrom","type":"text"},{"text":"Áp dụng đến ngày","align":"center","sortable":false,"id":"appliedTo","display":"appliedTo","type":"text"},{"text":"Thời gian cập nhật","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"time"}],"headersTtVmaConversionType":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên công thức","align":"center","sortable":false,"id":"functionName","display":"functionName","type":"text","style":{"min-width":"27.1em","max-width":"27.1em"}},{"text":"Trọng số","align":"center","sortable":false,"id":"conversionSequence","display":"conversionSequence","type":"text","style":{"min-width":"21.3em","max-width":"21.3em"}},{"text":"Đơn vị","align":"center","sortable":false,"id":"conversionUnit","display":"conversionUnit","type":"text","style":{"min-width":"20em","max-width":"20em"}},{"text":"Thời gian cập nhật","align":"center","sortable":false,"id":"modifiedDate","display":"modifiedDate","type":"time","style":{"min-width":"20em","max-width":"20em"}}],"headersDsTauAll":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"IMO","align":"center","sortable":false,"id":"imoNumber","display":"imoNumber","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time","style":{"min-width":"14em","max-width":"14em"}},{"text":"Thời gian rời","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"time","style":{"min-width":"14em","max-width":"14em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"arrivalShipAgency","display":"arrivalShipAgency","type":"select","items":"shipAgencyItems","style":{"min-width":"19em","max-width":"19em"}}],"headersDsDuTau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time"},{"text":"Thời gian đi","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"time"},{"text":"Ngày bắt giữ","align":"center","sortable":false,"id":"securityDate","display":"securityDate","type":"time"},{"text":"Ngày giải tỏa","align":"center","sortable":false,"id":"evacuateDate","display":"evacuateDate","type":"time"},{"text":"Lý do bắt giữ","align":"center","sortable":false,"id":"securityReason","display":"securityReason","type":"text"},{"text":"Cơ quan ra quyết định <br> bắt giữ","align":"center","sortable":false,"display":"securityCompanyName","id":"securityOfficeCode","type":"text"},{"text":"Địa điểm <br> bắt dữ","align":"center","sortable":false,"id":"securityPlace","display":"securityPlace","type":"text"},{"text":"Cơ quan ra quyết định <br> giải tỏa","align":"center","sortable":false,"id":"evacuateCompanyName","display":"evacuateCompanyName","type":"text"},{"text":"SQĐ bắt giữ","align":"center","sortable":false,"id":"securityOfficialNo","display":"securityOfficialNo","type":"text"},{"text":"SQĐ giải tỏa","align":"center","sortable":false,"id":"evacuateOfficialNo","display":"evacuateOfficialNo","type":"text"}],"headersDsTauDichVu":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"shipName","display":"shipName","type":"text","style":{"min-width":"15.1em","max-width":"15.1em"}},{"text":"Công suất máy","align":"center","sortable":false,"id":"power","display":"power","type":"text"},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"NT","align":"center","sortable":false,"id":"nt","display":"nt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Ghi chú","align":"center","sortable":false,"id":"remarks","display":"remarks","type":"text","style":{"min-width":"21em","max-width":"21em"}},{"text":"Giá dịch vụ (đồng/giờ)","align":"center","sortable":false,"display":"vndUnitPrice","id":"vndUnitPrice","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Giá dịch vụ (USD/giờ)","align":"center","sortable":false,"display":"usdUnitPrice","id":"usdUnitPrice","type":"text","style":{"min-width":"15em","max-width":"15em"}}],"headersDsThuTau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time"},{"text":"Thời gian đi","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"time"},{"text":"Số thuyền viên","align":"center","sortable":false,"id":"crewNumber","display":"crewNumber","type":"text"},{"text":"Thời gian <br> bắt đầu","align":"center","sortable":false,"id":"testingFrom","display":"testingFrom","type":"time"},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thời gian <br> kết thúc","align":"center","sortable":false,"display":"testingTo","id":"testingTo","type":"text"},{"text":"Trọng tải","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Chiều dài","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thuyền trưởng","align":"center","sortable":false,"id":"shipCaptain","display":"shipCaptain","type":"text"},{"text":"Mớn nước mũi","align":"center","sortable":false,"id":"shownDraftxF","display":"shownDraftxF","type":"text","style":{"min-width":"7em","max-width":"7em"}},{"text":"Mớn nước lái","align":"center","sortable":false,"id":"shownDraftxA","display":"shownDraftxA","type":"text","style":{"min-width":"7em","max-width":"7em"}},{"text":"Từ vị trí","align":"center","sortable":false,"id":"shiftingPortHarbourCode","display":"shiftingPortHarbourCode","type":"text"},{"text":"Đến vị trí","align":"center","sortable":false,"id":"shiftingPortWharfCode","display":"shiftingPortWharfCode","type":"text"},{"text":"Số người <br> theo tàu","align":"center","sortable":false,"id":"evacuateOfficialNo","display":"evacuateOfficialNo","type":"text"},{"text":"Số giấy phép","align":"center","sortable":false,"id":"certificateNo","display":"certificateNo","type":"text"}],"headersDsGhiChu":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Ghi chú tàu","align":"center","sortable":false,"id":"remarks","display":"remarks","type":"text","style":{"min-width":"33.7em","max-width":"33.7em"}},{"text":"Có hiển thị cảnh báo","align":"center","sortable":false,"id":"coHienThiCanhBao","display":"coHienThiCanhBao","type":"select","items":"coHienThiCanhBaoItems","style":{"min-width":"10em","max-width":"10em"}},{"text":"Ngày ghi chú","align":"center","sortable":false,"id":"securityDate","display":"securityDate","type":"time"},{"text":"Ngày hết hiệu lực ghi chú","align":"center","sortable":false,"id":"evacuateDate","display":"evacuateDate","type":"time"},{"text":"Không giải quyết rời cảng","align":"center","sortable":false,"id":"khongGiaiQuyetRoiCang","display":"khongGiaiQuyetRoiCang","type":"select","items":"khongGiaiQuyetRoiCangItems","style":{"min-width":"12em","max-width":"12em"}}],"headersDsHaXuong":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time"},{"text":"Thời gian đi","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"time"},{"text":"Thời gian bắt đầu <br> thả xuồng","align":"center","sortable":false,"id":"launchingFrom","display":"launchingFrom","type":"time"},{"text":"Thời gian kết thúc <br> thả xuồng","align":"center","sortable":false,"id":"launchingTo","display":"launchingTo","type":"time"},{"text":"Mục đích thả xuồng","align":"center","sortable":false,"id":"launchingReason","display":"launchingReason","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Khu vực thả xuồng","align":"center","sortable":false,"id":"launchingPlace","display":"launchingPlace","type":"text","style":{"min-width":"14.8em","max-width":"14.8em"}}],"headersHoaTieuDanTau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Lượt","align":"center","sortable":false,"id":"noticeShipType","display":"noticeShipTypeName","type":"select","items":"noticeShipTypeItems"},{"text":"Hoa tiêu","align":"center","sortable":false,"id":"pilotList","display":"pilotList","type":"select","items":"pilotItems"},{"text":"Bến cảng <br> lên tàu","align":"center","sortable":false,"id":"anchoringPortHarbourCode","display":"anchoringPortHarbourName","type":"select","items":"portHarbourItems"},{"text":"Vị trí <br> lên tàu","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems"},{"text":"Bến cảng <br> rời tàu","align":"center","sortable":false,"id":"shiftingPortHarbourCode","display":"shiftingPortHarbourName","type":"select","items":"portHarbourItems"},{"text":"Vị trí <br> rời tàu","align":"center","sortable":false,"id":"shiftingPortWharfCode","display":"shiftingPortWharfName","type":"select","items":"portWharfItems"},{"text":"Thời gian <br> lên tàu","align":"center","sortable":false,"id":"pilotDateFrom","display":"pilotDateFrom","type":"time"},{"text":"Thời gian <br> rời tàu","align":"center","sortable":false,"id":"pilotDateTo","display":"pilotDateTo","type":"time"}],"headersDsKeHoachChuyenTuyen":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"14.5em","max-width":"14.5em"}},{"text":"Tuyến","align":"center","sortable":false,"id":"chanelCodeList","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems","style":{"min-width":"18.5em","max-width":"18.5em"}},{"text":"Đơn vị khai thác","align":"center","sortable":false,"style":{"min-width":"17.5em","max-width":"17.5em"},"id":"shipOperatorCode","display":"shipOperatorName","type":"select","items":"shipOperatorItems"},{"text":"Tháng","align":"center","sortable":false,"style":{"min-width":"11.6em","max-width":"11.6em"},"id":"scheduleMonth","display":"scheduleMonth","type":"select","items":"thangItems"},{"text":"Năm","align":"center","sortable":false,"style":{"min-width":"11.6em","max-width":"11.6em"},"id":"scheduleYear","display":"scheduleYear","type":"select","items":"thangItems"},{"text":"Số chuyến trong tháng","align":"center","sortable":false,"style":{"min-width":"12em","max-width":"12em"},"id":"voyageNo","display":"voyageNo","type":"text"}],"headersDsKhangNghi":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"14em","max-width":"14em"}},{"text":"Nội dung","align":"center","sortable":false,"id":"protestRemarks","display":"protestRemarks","type":"text","style":{"min-width":"17em","max-width":"17em"}},{"text":"Thời gian nhận <br> kháng cáo","align":"center","sortable":false,"id":"protestDate","display":"protestDate","type":"time","style":{"min-width":"10.5em","max-width":"10.5em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Chủ tàu","align":"center","sortable":false,"id":"shipOwnerCode","display":"shipOwnerName","type":"select","items":"shipOwnerItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Khai thác","align":"center","sortable":false,"id":"shipOperatorCode","display":"shipOperatorName","type":"select","items":"shipOperatorItems","style":{"min-width":"15em","max-width":"15em"}}],"headersNeoTau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Lượt","align":"center","sortable":false,"id":"noticeShipType","display":"noticeShipTypeName","type":"select","items":"noticeShipTypeItems","style":{"min-width":"9.6em","max-width":"9.6em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"Cầu/ phao","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfCode","type":"select","items":"portWharfItems","style":{"min-width":"18em","max-width":"18em"}},{"text":"Ngày đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time","style":{"min-width":"9em","max-width":"9em"}},{"text":"Thời gian bắt đầu neo","align":"center","sortable":false,"id":"anchoringDateFrom","type":"time","display":"anchoringDateFrom","style":{"min-width":"9em","max-width":"9em"}},{"text":"Thời gian kết thúc neo","align":"center","sortable":false,"id":"anchoringDateTo","display":"anchoringDateTo","type":"time"},{"text":"Số giờ neo","align":"center","sortable":false,"id":"anchoringDuration","display":"anchoringDuration","type":"text"},{"text":"Số giờ neo <br> tính phí nội","align":"center","sortable":false,"id":"anchorageDomesticDuration","display":"anchorageDomesticDuration","type":"text"},{"text":"Số giờ neo <br> tính phí ngoại","align":"center","sortable":false,"id":"anchorageForeignDuration","display":"anchorageForeignDuration","type":"text"},{"text":"Số giờ neo <br> không tính phí","align":"center","sortable":false,"id":"anchorageFreeDuration","display":"anchorageFreeDuration","type":"text"}],"headersDsSuaChuaTau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"12.5em","max-width":"12.5em"}},{"text":"Thời gian đến","align":"center","sortable":false,"id":"repairingFrom","display":"repairingFrom","type":"time"},{"text":"Số quyết định","align":"center","sortable":false,"id":"shipYardOfficialNo","display":"shipYardOfficialNo","type":"text"},{"text":"Đơn vị sửa chữa","align":"center","sortable":false,"id":"shipYardCompanyName","display":"shipYardCompanyName","type":"text","style":{"min-width":"14em","max-width":"14em"}},{"text":"Thời gian đi","align":"center","sortable":false,"id":"repairingTo","display":"repairingTo","type":"time"},{"text":"Lý do sửa","align":"center","sortable":false,"id":"repairingReason","display":"repairingReason","type":"text","style":{"min-width":"12.1em","max-width":"12.1em"}},{"text":"Từ ngày","align":"center","sortable":false,"id":"repairingFrom","display":"repairingFrom","type":"time"},{"text":"Đến ngày","align":"center","sortable":false,"id":"repairingTo","display":"repairingTo","type":"time"}],"headersDsXacNhanAnToan":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"shipName","display":"shipName","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"IMO","align":"center","sortable":false,"id":"imoNumber","display":"imoNumber","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Xác nhận <br> an toàn","align":"center","sortable":false,"id":"violated","display":"violated","type":"select","items":"violatedItems","style":{"min-width":"10em","max-width":"10em"}},{"text":"Loại tàu","align":"center","sortable":false,"id":"shipTypeCode","type":"select","display":"shipTypeName","items":"shipTypeItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Công dụng","align":"center","sortable":false,"id":"shipTypeMT","display":"shipTypeMTName","type":"select","items":"shipTypeMTItems"},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"NT","align":"center","sortable":false,"id":"nt","display":"nt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"LOA(m)","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"Breadth(m)","align":"center","sortable":false,"id":"breadth","display":"breadth","type":"text","style":{"min-width":"5.1em","max-width":"5.1em"}},{"text":"Mớn nước t.kế(m)","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text"},{"text":"Chiều cao t.không(m)","align":"center","sortable":false,"id":"clearanceHeight","display":"clearanceHeight","type":"text"},{"text":"Cấp độ an ninh","align":"center","sortable":false,"id":"securityLevelName","display":"securityLevelName","type":"text"},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Chủ tàu","align":"center","sortable":false,"id":"shipOwnerCode","display":"shipOwnerName","type":"select","items":"shipOwnerItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Người khai thác","align":"center","sortable":false,"id":"shipOperatorCode","display":"shipOperatorName","type":"select","items":"shipOperatorItems","style":{"min-width":"20em","max-width":"20em"}}],"headersDsTauThanhThai":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"shipName","display":"shipName","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"IMO","align":"center","sortable":false,"id":"imoNumber","display":"imoNumber","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Phá dỡ","align":"center","sortable":false,"id":"deconstructed","display":"deconstructed","type":"select","items":"deconstructedItems","style":{"min-width":"5em","max-width":"5em"}},{"text":"Loại tàu","align":"center","sortable":false,"id":"shipTypeCode","type":"select","display":"shipTypeName","items":"shipTypeItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Công dụng","align":"center","sortable":false,"id":"shipTypeMT","display":"shipTypeMTName","type":"select","items":"shipTypeMTItems"},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"NT","align":"center","sortable":false,"id":"nt","display":"nt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"LOA(m)","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"Breadth(m)","align":"center","sortable":false,"id":"breadth","display":"breadth","type":"text","style":{"min-width":"5.1em","max-width":"5.1em"}},{"text":"Mớn nước t.kế(m)","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text"},{"text":"Chiều cao t.không(m)","align":"center","sortable":false,"id":"clearanceHeight","display":"clearanceHeight","type":"text"},{"text":"Cấp độ an ninh","align":"center","sortable":false,"id":"securityLevelName","display":"securityLevelName","type":"text"},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Chủ tàu","align":"center","sortable":false,"id":"shipOwnerCode","display":"shipOwnerName","type":"select","items":"shipOwnerItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Người khai thác","align":"center","sortable":false,"id":"shipOperatorCode","display":"shipOperatorName","type":"select","items":"shipOperatorItems","style":{"min-width":"20em","max-width":"20em"}}],"headersDsKhNeoDau":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Lượt","align":"center","sortable":false,"id":"noticeShipType","display":"noticeShipTypeName","type":"select","items":"noticeShipTypeItems","style":{"min-width":"9.6em","max-width":"9.6em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"Cầu/ phao","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfCode","type":"select","items":"portWharfItems","style":{"min-width":"18em","max-width":"18em"}},{"text":"Ngày đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time","style":{"min-width":"9em","max-width":"9em"}},{"text":"Thời gian bắt đầu neo","align":"center","sortable":false,"id":"anchoringDateFrom","type":"time","display":"anchoringDateFrom","style":{"min-width":"9em","max-width":"9em"}},{"text":"Thời gian kết thúc neo","align":"center","sortable":false,"id":"anchoringDateTo","display":"anchoringDateTo","type":"time"},{"text":"Số giờ neo","align":"center","sortable":false,"id":"anchoringDuration","display":"anchoringDuration","type":"text"},{"text":"Số giờ neo <br> tính phí nội","align":"center","sortable":false,"id":"anchorageDomesticDuration","display":"anchorageDomesticDuration","type":"text"},{"text":"Số giờ neo <br> tính phí ngoại","align":"center","sortable":false,"id":"anchorageForeignDuration","display":"anchorageForeignDuration","type":"text"},{"text":"Số giờ neo <br> không tính phí","align":"center","sortable":false,"id":"anchorageFreeDuration","display":"anchorageFreeDuration","type":"text"}],"headersDsTauBien":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"shipName","display":"shipName","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"IMO","align":"center","sortable":false,"id":"imoNumber","display":"imoNumber","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Loại tàu","align":"center","sortable":false,"id":"shipTypeCode","type":"select","display":"shipTypeName","items":"shipTypeItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Công dụng","align":"center","sortable":false,"id":"shipTypeMT","display":"shipTypeMTName","type":"select","items":"shipTypeMTItems"},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"NT","align":"center","sortable":false,"id":"nt","display":"nt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"LOA(m)","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"Breadth(m)","align":"center","sortable":false,"id":"breadth","display":"breadth","type":"text","style":{"min-width":"5.1em","max-width":"5.1em"}},{"text":"Mớn nước t.kế(m)","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text"},{"text":"Chiều cao t.không(m)","align":"center","sortable":false,"id":"clearanceHeight","display":"clearanceHeight","type":"text"},{"text":"Cấp độ an ninh","align":"center","sortable":false,"id":"securityLevelName","display":"securityLevelName","type":"text"},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Chủ tàu","align":"center","sortable":false,"id":"shipOwnerCode","display":"shipOwnerName","type":"select","items":"shipOwnerItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Người khai thác","align":"center","sortable":false,"id":"shipOperatorCode","display":"shipOperatorName","type":"select","items":"shipOperatorItems","style":{"min-width":"20em","max-width":"20em"}}],"headersTauTrongCang":[{"text":"Thời gian","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"text"},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"IMO","align":"center","sortable":false,"id":"imoNumber","type":"text","display":"imoNumber"},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text"},{"text":"Số đăng ký","align":"center","sortable":false,"id":"registryNumber","display":"registryNumber","type":"text"},{"text":"Vị trí","align":"center","sortable":false,"id":"portHarbourCode","display":"portHarbourName","type":"text"},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"text"}],"headersTauKhDieuDong":[{"text":"Thời <br> gian <br> TIME","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"text","style":{}},{"text":"Tên tàu <br> VESSEL","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"width":"25%"}},{"text":"Mớn <br> nước <br> DRAFT","align":"center","sortable":false,"id":"maxDraft","type":"text","display":"maxDraft","style":{}},{"text":"Chiều <br> dài <br> LOA","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{}},{"text":"Dung tích <br> GRT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{}},{"text":"Trọng tải <br> DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{}},{"text":"Tàu lai <br> TUG","align":"center","sortable":false,"id":"tugboatList","display":"tugboatList","type":"text","style":{}},{"text":"Từ <br> FROM","align":"center","sortable":false,"id":"portHarbourCode","display":"portHarbourName","type":"text","style":{"width":"16%"}},{"text":"Đến <br> TO","align":"center","sortable":false,"id":"portWharfCode","display":"portWharfName","type":"text","style":{"width":"16%"}},{"text":"Hoa tiêu <br> PILOT","align":"center","sortable":false,"id":"pilotList","display":"pilotList","type":"text","style":{"width":"16%"}},{"text":"Đại lý <br> AGENT","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"text","style":{"width":"16%"}},{"text":"Tuyến luồng <br> ROUTE","align":"center","sortable":false,"id":"chanelName","display":"chanelName","type":"text","style":{}},{"text":"Ghi chú <br> cảng vụ <br> NOTE","align":"center","sortable":false,"id":"maritimeRemarks","display":"maritimeRemarks","type":"text","style":{}}],"headersTauDenCang":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"LOA","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Mớn nước","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Vị trí đến","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems"},{"text":"Tuyến luồng","align":"center","sortable":false,"id":"chanelCodeListName","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Hoa tiêu","align":"center","sortable":false,"id":"pilotNames","display":"pilotNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Tàu lai","align":"center","sortable":false,"id":"tugBoatNames","display":"tugBoatNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"16em","max-width":"16em"}}],"headersPTTNDDenCang":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Số đăng ký","align":"center","sortable":false,"id":"registryNumber","type":"text","display":"registryNumber"},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Chiều dài","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Mớn nước","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Vị trí neo đậu","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"17em","max-width":"17em"}},{"text":"Tuyến luồng","align":"center","sortable":false,"id":"chanelCodeList","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems","style":{"min-width":"16em","max-width":"16em"}}],"headersKHTauDiChuyen":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"LOA","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Mớn nước","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thời gian điều động","align":"center","sortable":false,"id":"shiftingDate","display":"shiftingDate","type":"time"},{"text":"Vị trí neo đậu <br> từ","align":"center","sortable":false,"id":"from","display":"from","type":"text"},{"text":"Vị trí neo đậu <br> đến","align":"center","sortable":false,"id":"to","display":"to","type":"text"},{"text":"Tuyến luồng","align":"center","sortable":false,"id":"chanelCodeListName","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems"},{"text":"Hoa tiêu","align":"center","sortable":false,"id":"pilotNames","display":"pilotNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Tàu lai","align":"center","sortable":false,"id":"tugBoatNames","display":"tugBoatNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"nameOfShipownersAgents","display":"nameOfShipownersAgents","type":"select","items":"shipAgencyItems","style":{"min-width":"14em","max-width":"14em"}}],"headersTauRoiCang":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Quốc tịch","align":"center","sortable":false,"id":"flagStateOfShip","type":"select","display":"flagStateOfShipName","items":"quocTichItems"},{"text":"LOA","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Mớn nước","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Thời gian rời","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Vị trí neo đậu","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems"},{"text":"Tuyến luồng","align":"center","sortable":false,"id":"chanelCodeListName","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Hoa tiêu","align":"center","sortable":false,"id":"pilotNames","display":"pilotNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Tàu lai","align":"center","sortable":false,"id":"tugBoatNames","display":"tugBoatNames","type":"text","style":{"min-width":"16em","max-width":"16em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"16em","max-width":"16em"}}],"headersPTTNDRoiCang":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Số đăng ký","align":"center","sortable":false,"id":"registryNumber","type":"text","display":"registryNumber"},{"text":"Hô hiệu","align":"center","sortable":false,"id":"callSign","display":"callSign","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Chiều dài","align":"center","sortable":false,"id":"loa","display":"loa","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Mớn nước","align":"center","sortable":false,"id":"maxDraft","display":"maxDraft","type":"text","style":{"min-width":"5em","max-width":"5em"}},{"text":"Loại hàng hóa","align":"center","sortable":false,"id":"cargoType","display":"cargoTypeName","type":"select","items":"cargoTypeItems"},{"text":"Vị trí neo đậu","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Dự kiến rời","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"text","style":{"min-width":"15em","max-width":"15em"}},{"text":"Đại lý","align":"center","sortable":false,"id":"shipAgencyCode","display":"shipAgencyName","type":"select","items":"shipAgencyItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Tuyến luồng","align":"center","sortable":false,"id":"chanelCodeList","display":"chanelCodeListName","type":"select","items":"chanelCodeListItems","style":{"min-width":"16em","max-width":"16em"}}],"headerTauLaiHoTro":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text","style":{"min-width":"16.6em","max-width":"16.6em"}},{"text":"Lượt","align":"center","sortable":false,"id":"noticeShipType","display":"noticeShipTypeName","type":"select","items":"noticeShipTypeItems","style":{"min-width":"12.6em","max-width":"12.6em"}},{"text":"Bến cảng","align":"center","sortable":false,"id":"anchoringPortHarbourCode","display":"anchoringPortHarbourName","type":"select","items":"portHarbourItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Vị trí","align":"center","sortable":false,"id":"anchoringPortWharfCode","display":"anchoringPortWharfName","type":"select","items":"portWharfItems","style":{"min-width":"16em","max-width":"16em"}},{"text":"Thời gian <br> bắt đầu","align":"center","sortable":false,"id":"tugDateFrom","display":"tugDateFrom","type":"time"},{"text":"Thời gian <br> kết thúc","align":"center","sortable":false,"id":"tugDateTo","display":"tugDateTo","type":"time"}],"headersXepDoHang":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên tàu","align":"center","sortable":false,"id":"nameOfShip","display":"nameOfShip","type":"text"},{"text":"Thời gian đến","align":"center","sortable":false,"id":"timeOfArrival","display":"timeOfArrival","type":"time"},{"text":"Thời gian đi","align":"center","sortable":false,"id":"timeOfDeparture","display":"timeOfDeparture","type":"time"},{"text":"Thời gian <br> làm hàng","align":"center","sortable":false,"id":"unloadingDate","display":"unloadingDate","type":"time"},{"text":"Hình thức H.H <br> qua cảng","align":"center","sortable":false,"id":"cargoCategory","display":"cargoCategoryName","type":"select","items":"cargoCategoryItems"},{"text":"Bến cảng <br> làm hàng","align":"center","sortable":false,"id":"portHarbourCode","display":"portHarbourName","type":"select","items":"portHarbourItems"},{"text":"Vị trí làm hàng","align":"center","sortable":false,"id":"portWharfCode","display":"portWharfName","type":"select","items":"portWharfItems"},{"text":"Loại hàng","align":"center","sortable":false,"id":"cargoType","display":"cargoTypeName","type":"select","items":"cargo_115Items"},{"text":"Hàng hóa","align":"center","sortable":false,"id":"cargoCode","display":"cargoName","type":"select","items":"cargo_124Items"},{"text":"Số container","align":"center","sortable":false,"id":"teusQuantity","display":"teusQuantity","type":"text"},{"text":"Số TEU","align":"center","sortable":false,"id":"teusQuantity","display":"teusQuantity","type":"text"},{"text":"Số tấn","align":"center","sortable":false,"id":"quantity","display":"quantity","type":"text"},{"text":"Có hàng <br> nguy hiểm","align":"center","sortable":false,"id":"coHangNguyHiem","display":"coHangNguyHiem","type":"select","items":"coHangNguyHiemItems"},{"text":"Ghi chú","align":"center","sortable":false,"id":"description","display":"description","type":"text"}],"headersDsThuyNoiDia":[{"text":"STT","align":"center","sortable":false,"id":"stt","type":"text","style":{"width":"3em","min-width":"3em","max-width":"3em"}},{"text":"Tên phương tiện","align":"center","sortable":false,"id":"shipName","display":"shipName","type":"text"},{"text":"Loại tàu","align":"center","sortable":false,"id":"shipTypeCode","display":"shipTypeName","type":"select","items":"shipTypeItems","style":{"min-width":"15em","max-width":"15em"}},{"text":"Cấp PT","align":"center","sortable":false,"id":"vrCode","display":"vrCode","type":"text"},{"text":"Tàu kéo","align":"center","sortable":false,"id":"tugBoatName","display":"tugBoatName","type":"text"},{"text":"GT","align":"center","sortable":false,"id":"gt","display":"gt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"DWT","align":"center","sortable":false,"id":"dwt","display":"dwt","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"LOA(m)","align":"center","sortable":false,"id":"loa","type":"text","style":{"min-width":"4em","max-width":"4em"}},{"text":"Breadth(m)","align":"center","sortable":false,"id":"breadth","display":"breadth","type":"text","style":{"min-width":"5.1em","max-width":"5.1em"}},{"text":"Công suất máy(HP)","align":"center","sortable":false,"id":"power","display":"power","type":"text"},{"text":"Chủ tàu","align":"center","sortable":false,"id":"shipOwnerCode","display":"shipOwnerName","type":"select","items":"shipOwnerItems","style":{"min-width":"20em","max-width":"20em"}},{"text":"Địa chỉ","align":"center","sortable":false,"id":"address","display":"address","type":"text","style":{"min-width":"20em","max-width":"20em"}},{"text":"Thuyền trưởng","align":"center","sortable":false,"id":"nameOfMaster","display":"nameOfMaster","type":"text"},{"text":"Hạng bằng TT","align":"center","sortable":false,"id":"hangBangDSTND","display":"hangBangDSTND","type":"text"},{"text":"Máy trưởng","align":"center","sortable":false,"id":"chiefOfEngineer","display":"chiefOfEngineer","type":"text"},{"text":"Hạng bằng MT","align":"center","sortable":false,"id":"hangBangMtDSTND","display":"hangBangMtDSTND","type":"text"}],"TPHS_ThongTinTauBien":[{"name":"Giấy tờ tàu","code":"DanhSachGiayToTau"},{"name":"Vị trí neo đậu","code":"DanhSachViTriNeoDauTaiCang"},{"name":"Dich chuyển vị trí","code":"DanhSachTauDiChuyen"},{"name":"Sửa chữa","code":"DanhSachSuaChuaTau"},{"name":"Hạ xuồng","code":"DanhSachHaXuong"},{"name":"Thử tàu","code":"DanhSachThuTau"},{"name":"Giữ tàu","code":"DanhSachDuTau"},{"name":"Vi phạm giấy phép","code":"VIPHAMGIAYPHEP"},{"name":"Ghi chú, cảnh báo","code":"DanhSachGhiChuCanhBao"},{"name":"Lịch sử thay đổi","code":"LICHSUTHAYDOI"}],"TPHS_ThongTinPTTND":[{"name":"Giấy tờ phương tiện","code":"GIAYTOPHUONGTIEN"},{"name":"Hành trình phương tiện","code":"HANHTRINHPHUONGTIEN"},{"name":"Vị trí neo đậu","code":"DanhSachViTriNeoDauTaiCang"},{"name":"Vi phạm giấy phép","code":"VIPHAMGIAYPHEP"},{"name":"Ghi chú, cảnh báo","code":"DanhSachGhiChuCanhBao"},{"name":"Lịch sử thay đổi","code":"LICHSUTHAYDOI"}],"thangItems":[{"itemText":"1","itemValue":1},{"itemText":"2","itemValue":2},{"itemText":"3","itemValue":3},{"itemText":"4","itemValue":4},{"itemText":"5","itemValue":5},{"itemText":"6","itemValue":6},{"itemText":"7","itemValue":7},{"itemText":"8","itemValue":8},{"itemText":"9","itemValue":9},{"itemText":"10","itemValue":10},{"itemText":"11","itemValue":11},{"itemText":"12","itemValue":12}],"markedAsArrival":{"0":"Chưa có hồ sơ lượt vào","1":"Chưa lập kế hoạch đến","2":"Chờ xác nhận kế hoạch","3":"Chuyển lãnh đạo chờ ký số","4":"Chuyển văn thư chờ đóng dấu","5":"Tạo kế hoạch điều động","6":"Hủy kế hoạch điều động","7":"Lãnh đạo trả lại","8":"Đã duyệt kế hoạch điều động","9":"Đã cấp kế hoạch điều động"},"markedAsDeparture":{"0":"Chưa có hồ sơ lượt rời","1":"Chưa lập kế hoạch rời","2":"Chờ xác nhận kế hoạch rời","3":"Chuyển lãnh đạo chờ ký số","4":"Chuyển văn thư chờ đóng dấu","5":"Chuyển thủ tục tạo giấy phép rời cảng","6":"Hủy giấy phép rời cảng","7":"Lãnh đạo trả lại","8":"Đã duyệt giấy phép rời cảng","9":"Đã cấp giấy phép rời cảng"},"role_filter_status_out":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":48,"title":"Tàu dịch vụ","counter":"_ _","code":408,"type":"DanhSachTauDichVu","url":"countDmVmaTugboatURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"},{"id":34,"title":"Kế hoạch tàu thuyền vào cảng","counter":"_ _","code":304,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu thuyền rời cảng","counter":"_ _","code":303,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":37,"title":"Tàu lai hỗ trợ","counter":"_ _","code":307,"type":"DanhSachTauLaiHoTro","url":"countVmaScheduleTugboatURL"},{"id":38,"title":"Hoa tiêu dẫn tàu","counter":"_ _","code":308,"type":"DanhSachHoaTieuDanTau","url":"countVmaSchedulePilotURL"},{"id":40,"title":"Nhập, tách đoàn","counter":"_ _","code":400,"type":"DanhSachNhapTachDoan","url":"countVmaScheduleMergingURL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":37,"title":"Xếp dỡ hàng","counter":"_ _","code":307,"type":"DanhSachXepDoHang","url":"countVmaScheduleCargolistURL"},{"id":44,"title":"Giấy tờ tàu","counter":"_ _","code":406,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"},{"id":46,"title":"Kháng nghị hàng hải","counter":"_ _","code":406,"type":"DanhSachKhangNghiHangHai","url":"countVmaItineraryProtestURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"},{"id":31,"title":"Tàu biển","counter":"_ _","code":304,"type":"DanhSachTauBien","url":"countVmaShip_Ship_URL"},{"id":31,"title":"PT thủy nội địa","counter":"_ _","code":305,"type":"DanhSachPhuongTienThuyNoiDia","url":"countVmaShip_Boat_URL"},{"id":31,"title":"Tàu thanh thải","counter":"_ _","code":305,"type":"DanhSachTauThanhThai","url":"countVmaShip_Ship_URL"},{"id":31,"title":"Xác nhận an toàn an ninh hàng hải","counter":"_ _","code":305,"type":"DanhSachXacNhanAnToanAnNinh","url":"countVmaShip_Ship_URL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_pttnd_out":{"id":-3,"index":3,"title":"Quản lý chuyến tàu PTTNĐ","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"PTTNĐ vào cảng","counter":"_ _","code":304,"type":"DanhSachPTTNDDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":33,"title":"PTTNĐ rời cảng","counter":"_ _","code":303,"type":"DanhSachPTTNDRoiCang","url":"countVmaItinerarySchedule_Leave_URL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_200dwt":{"id":-3,"index":3,"title":"Tàu thuyền < 200 DWT","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Tàu thuyền <200 DWT","counter":"_ _","code":304,"type":"DanhSach<200DWTVao","url":"countVmaItinerarySchedule_Come_URL"},{"id":33,"title":"Tàu thuyền <200 DWT","counter":"_ _","code":303,"type":"DanhSach<200DWTRoi","url":"countVmaItinerarySchedule_Leave_URL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_tau_dong_moi":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch tàu vào cảng","counter":"_ _","code":304,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu rời cảng","counter":"_ _","code":303,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":46,"title":"Kháng nghị hàng hải","counter":"_ _","code":406,"type":"DanhSachKhangNghiHangHai","url":"countVmaItineraryProtestURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"},{"id":50,"title":"Giấy tờ tàu","counter":"_ _","code":407,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"},{"id":37,"title":"Xếp dỡ hàng","counter":"_ _","code":307,"type":"DanhSachXepDoHang","url":"countVmaScheduleCargolistURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_tau_200dwt":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch tàu < 200 DWT vào cảng","counter":"_ _","code":304,"type":"DanhSach<200DWTVao","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu < 200 DWT rời cảng","counter":"_ _","code":303,"type":"DanhSach<200DWTRoi","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":46,"title":"Kháng nghị hàng hải","counter":"_ _","code":406,"type":"DanhSachKhangNghiHangHai","url":"countVmaItineraryProtestURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"},{"id":50,"title":"Giấy tờ tàu","counter":"_ _","code":407,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"},{"id":37,"title":"Xếp dỡ hàng","counter":"_ _","code":307,"type":"DanhSachXepDoHang","url":"countVmaScheduleCargolistURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_pttnd_den_roi":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch PTTNĐ vào cảng","counter":"_ _","code":304,"type":"DanhSachPTTNDDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch PTTNĐ rời cảng","counter":"_ _","code":303,"type":"DanhSachPTTNDRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":46,"title":"Kháng nghị hàng hải","counter":"_ _","code":406,"type":"DanhSachKhangNghiHangHai","url":"countVmaItineraryProtestURL"},{"id":37,"title":"Xếp dỡ hàng","counter":"_ _","code":307,"type":"DanhSachXepDoHang","url":"countVmaScheduleCargolistURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"},{"id":48,"title":"Xem lịch sử vào rời","counter":"_ _","code":407,"type":"XemLichSuVaoRoi","url":"countVmaScheduleXlineURL"},{"id":50,"title":"Giấy tờ tàu","counter":"_ _","code":407,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_pttnd_ke_hoach":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch tàu thuyền vào cảng","counter":"_ _","code":304,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu thuyền rời cảng","counter":"_ _","code":303,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_ke_hoach":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch tàu thuyền vào cảng","counter":"_ _","code":304,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu thuyền rời cảng","counter":"_ _","code":303,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":44,"title":"Giấy tờ tàu","counter":"_ _","code":406,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineSailingURL"},{"id":48,"title":"Tàu dịch vụ","counter":"_ _","code":408,"type":"DanhSachTauDichVu","url":"countDmVmaTugboatURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"role_filter_status_thu_tuc":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":33,"title":"Thủ tục tàu đến cảng","counter":"_ _","code":303,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":35,"title":"Thủ tục tàu rời cảng","counter":"_ _","code":305,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":37,"title":"Xếp dỡ hàng","counter":"_ _","code":307,"type":"DanhSachXepDoHang","url":"countVmaScheduleCargolistURL"},{"id":36,"title":"Tàu neo đậu","counter":"_ _","code":306,"type":"DanhSachNeoTau","url":"countVmaScheduleAnchorage_Ship_URL"},{"id":44,"title":"Giấy tờ tàu","counter":"_ _","code":406,"type":"DanhSachGiayToTau","url":"countVmaCertificateURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"},{"id":46,"title":"Kháng nghị hàng hải","counter":"_ _","code":406,"type":"DanhSachKhangNghiHangHai","url":"countVmaItineraryProtestURL"},{"id":47,"title":"KH tàu chạy chuyên tuyến","counter":"_ _","code":407,"type":"DanhSachKeHoachChuyenTuyen","url":"countVmaScheduleXlineSailingURL"},{"id":48,"title":"Tàu dịch vụ","counter":"_ _","code":408,"type":"DanhSachKeHoachTauDichVu","url":"countVmaScheduleXlineURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"filter_part_tau":{"id":-3,"index":3,"title":"Quản lý chuyến tàu","id_active":"quan_ly_tau","action_active":"folder_open","items":[{"id":34,"title":"Kế hoạch tàu thuyền vào cảng","counter":"_ _","code":304,"type":"DanhSachTauDenCang","url":"countVmaItinerarySchedule_Come_URL"},{"id":32,"title":"Vị trí neo đậu tại cảng","counter":"_ _","code":302,"type":"DanhSachViTriNeoDauTaiCang","url":"countVmaScheduleAnchorage_Port_URL"},{"id":35,"title":"Kế hoạch tàu dịch chuyển","counter":"_ _","code":305,"type":"DanhSachTauDiChuyen","url":"countVmaScheduleShiftingURL"},{"id":33,"title":"Kế hoạch tàu thuyền rời cảng","counter":"_ _","code":303,"type":"DanhSachTauRoiCang","url":"countVmaItinerarySchedule_Leave_URL"},{"id":43,"title":"Thử tàu","counter":"_ _","code":403,"type":"DanhSachThuTau","url":"countVmaScheduleTestingURL"},{"id":41,"title":"Sửa chữa\t","counter":"_ _","code":401,"type":"DanhSachSuaChuaTau","url":"countVmaScheduleShipyardURL"},{"id":42,"title":"Hạ xuồng","counter":"_ _","code":402,"type":"DanhSachHaXuong","url":"countVmaScheduleLaunchingURL"},{"id":44,"title":"Giữ tàu","counter":"_ _","code":404,"type":"DanhSachDuTau","url":"countVmaScheduleSecurityURL"},{"id":45,"title":"Ghi chú, cảnh báo","counter":"_ _","code":405,"type":"DanhSachGhiChuCanhBao","url":"countVmaItineraryRemarksURL"}],"action":"folder","active":false,"type":"DanhSachTau"},"listThanhToan":[{"code":"vma_transaction_conversion","name":"Quy đổi trọng tải toàn phần","url":"countVmaTransactionConversionURL","counter":-1},{"code":"vma_transaction_type","name":"Phí, lệ phí","url":"countVmaTransactionTypeURL","counter":-1},{"code":"vma_transaction_function","name":"Công thức tính phí, miễn giảm","url":"countVmaTransactionFunctionURL","counter":-1},{"code":"vma_conversion_type","name":"Trọng số quy đổi ưu tiên","url":"countVmaConversionTypeURL","counter":-1}],"data":[{"portRegionName":"QNH - KHU VỰC HÒN GAI","portHarbourCode":"BC5","portWharfCode":"41650","certificateNo":"20055371_2/2020/CVHHQN","timeOfDeparture":"26/06/2020 18:00","portRegionCode":"027","tugboatList":"<br>CÁI LÂN 08,<br>GOLDEN 68,<br>HẠ LONG 08","timeOfArrival":"","loa":229,"portHarbourName":"Bến cảng tổng hợp Cái Lân","portWharfName":"Cầu 6 - Cái Lân","maxDraft":"8.04/9.25","timeOfApproval":"","shipAgencyCode":"0300437898006","maritimeRemarks":"","pilotList":"<br>Nguyễn Minh Châu,<br>Vũ Tuấn Thanh (B) -HT 3 -Công ty TNHH MTV Hoa tiêu hàng hải khu vực III","vmaItineraryScheduleId":19248,"shipAgencyName":"VOSA QUANG NINH","initFrom":"Khu neo Hòn Miều 2, HM2-6","dwt":81462.4,"nameOfShip":"ANTONIA  S","noticeShipType":"4","vmaScheduleShiftingId":"8306","gt":45263,"itineraryNo":"QNH.JUN2000638"}]}

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeTraCuu_vue__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeTraCuu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeTraCuu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NotFound_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NotFound_vue__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/permission',
    component: __WEBPACK_IMPORTED_MODULE_3__components_NotFound_vue___default.a
  }, {
    path: '/tra-cuu/:type/:documentTypeCode/:documentStatusCode/:stateDisplay',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeTraCuu_vue___default.a,
    props: true
  }, {
    path: '/tra-cuu/:type/:documentTypeCode/:documentStatusCode/:stateDisplay/:id',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeTraCuu_vue___default.a,
    props: true
  }]
}));

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export eventBus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__support_json__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__support_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__support_json__);












__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_toastr___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
  state: {
    initData: null,
    loading: false,
    loadingTable: false,
    loadingSubmit: false,
    error: null,
    docTypes: null,
    roleFilterStatus: null,
    userSignsData: null,
    otherData: {},
    itineraryNo: null,
    detailHs: null,
    maritimeCode: '',
    selectTauRoi: {},
    selectPTTND: {},
    selectTau: {},
    keHoachDen: {},
    totalTauDiChuyen: 0,
    itemFee: {},
    counterThongBaoPhi: 0,
    counterDaXuLy: 0,
    switch1: false,
    pttnd: false,
    noiChuyenlai: false,
    drawer: true
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    loadInitResource: function loadInitResource(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (state.initData == null) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var param = {};
          var orginURL = window.location.href;
          var coma = window.location.href.lastIndexOf('#/');
          if (coma > 0) {
            orginURL = window.location.href.substr(0, coma);
          }
          var url1 = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(orginURL + __WEBPACK_IMPORTED_MODULE_9__support_json___default.a.renderURLInit, param).then(function (response) {
              var serializable = response.data;
              resolve(serializable);
            }).catch(function (error) {
              console.log(error);
              reject(error);
            });
          });
          var url2 = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(orginURL + __WEBPACK_IMPORTED_MODULE_9__support_json___default.a.renderURLInit2, param).then(function (response) {
              var serializable = response.data;
              if (serializable && serializable['user']) {
                var user = serializable['user'];
                commit('setMaritimeCode', user['maritimeCode']);
              } else {
                commit('setMaritimeCode', '');
              }
              resolve(serializable);
            }).catch(function (error) {
              console.log(error);
              reject(error);
            });
          });
          var url3 = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(orginURL + __WEBPACK_IMPORTED_MODULE_9__support_json___default.a.renderURLInit3, param).then(function (response) {
              var serializable = response.data;
              resolve(serializable);
            }).catch(function (error) {
              console.log(error);
              reject(error);
            });
          });
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([url1, url2, url3]).then(function (results) {
            var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(results[0], results[1], results[2]);
            commit('setInitData', data);
            resolve(data);
          }).catch(function (xhr) {
            commit('setInitData', null);
            reject(null);
          });
        });
      } else {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          resolve(state.initData);
        });
      }
    },
    loadHomeDataTable: function loadHomeDataTable(_ref3, data) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          if (data.type === 'ke_hoach') {
            param.params['requestState'] = data.documentStatusCode;
          } else if (data.type === 'thu_tuc') {
            param.params['documentStatusCode'] = data.documentStatusCode;
          }
          param.params['isDTND'] = state.initData.user.isDTND;
          param.params['isDTNDCam'] = state.initData.user.isDTNDCam;
          var urlRequest = '';
          if (data.type === 'ke_hoach') {
            urlRequest = state.initData.getHoSoKeHoachTable;
          } else if (data.type === 'thu_tuc') {
            urlRequest = state.initData.getHoSoThuTucTable;
          } else if (data.type === 'lanh_dao') {
            urlRequest = state.initData.getHistoryTable;
            param.params['documentTypeCode'] = 'document_sign';
          } else if (data.type === 'van_thu') {
            urlRequest = state.initData.getHistoryTable;
            param.params['documentTypeCode'] = 'document_approve';
          } else {
            urlRequest = state.initData.getHoSoKeHoachTable;
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var serializable = response.data;
            console.log(serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    genCertificateNo: function genCertificateNo(_ref4, data) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.genCertificateNoURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    genDocumentaryCode: function genDocumentaryCode(_ref5, data) {
      var commit = _ref5.commit,
          state = _ref5.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.genDocumentaryCodeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    genDocumentNameVoy: function genDocumentNameVoy(_ref6, data) {
      var commit = _ref6.commit,
          state = _ref6.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.genDocumentNameVoyURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getSoChuyen: function getSoChuyen(_ref7, data) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getNumberOfArrivalDepartureInMonthURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    vmaScheduleShiftingExport: function vmaScheduleShiftingExport(_ref8, data) {
      var commit = _ref8.commit,
          state = _ref8.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['vmaScheduleShiftingExportURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    inKeHoachDieuDongTheoNgay: function inKeHoachDieuDongTheoNgay(_ref9, data) {
      var commit = _ref9.commit,
          state = _ref9.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['exportVmaScheduleAnchoragePortURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    keHoachDieuDongExport: function keHoachDieuDongExport(_ref10, data) {
      var commit = _ref10.commit,
          state = _ref10.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['keHoachDieuDongExportURL'], param).then(function (response) {
            var url = response.data['url'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    yeuCauGiayPhepVaoRoiExport: function yeuCauGiayPhepVaoRoiExport(_ref11, data) {
      var commit = _ref11.commit,
          state = _ref11.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['yeuCauGiayPhepVaoRoiExportURl'], param).then(function (response) {
            var url = response.data['url'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    vmaItineraryScheduleExport: function vmaItineraryScheduleExport(_ref12, data) {
      var commit = _ref12.commit,
          state = _ref12.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['vmaItineraryScheduleExportURL'], param).then(function (response) {
            var url = response.data['urlDownload'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemThongBaoVaoRoiCang: function xemThongBaoVaoRoiCang(_ref13, data) {
      var commit = _ref13.commit,
          state = _ref13.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xemThongBaoVaoRoiCang'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data);
            resolve({
              url: url
            });
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemThongBaoThuPhi: function xemThongBaoThuPhi(_ref14, data) {
      var commit = _ref14.commit,
          state = _ref14.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xemThongBaoThuPhi'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data);
            resolve({
              url: url
            });
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemLichSuVaoRoi: function xemLichSuVaoRoi(_ref15, data) {
      var commit = _ref15.commit,
          state = _ref15.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['historyComeOut'], param).then(function (response) {
            var url = window.URL.createObjectURL(response.data);
            resolve({
              url: url
            });
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    printPreviewPdf: function printPreviewPdf(_ref16, data) {
      var commit = _ref16.commit,
          state = _ref16.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var query = {};
          for (var key in data) {
            if (key !== 'urlKey') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData[data['urlKey']], param).then(function (response) {
            var url = response.data['url'] || '';
            resolve(url);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getScheduleAnchorageDuration: function getScheduleAnchorageDuration(_ref17, data) {
      var commit = _ref17.commit,
          state = _ref17.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleAnchoragePaymentDurationURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadWarningCauCang: function loadWarningCauCang(_ref18, data) {
      var commit = _ref18.commit,
          state = _ref18.state;

      var param = {
        params: data
      };
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.warningPortWharf, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadWarningPilot: function loadWarningPilot(_ref19, data) {
      var commit = _ref19.commit,
          state = _ref19.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.warningPilot, data).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadWarningTugboat: function loadWarningTugboat(_ref20, data) {
      var commit = _ref20.commit,
          state = _ref20.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.warningTugboat, data).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadWarning: function loadWarning(_ref21, data) {
      var commit = _ref21.commit,
          state = _ref21.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getWarningURL, data).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadThanhPhanTauBien: function loadThanhPhanTauBien(_ref22, data) {
      var commit = _ref22.commit,
          state = _ref22.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getThanhPhanTauBien, data).then(function (response) {
            var serializable = response.data;
            console.log(serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    countDanhSachTauBien: function countDanhSachTauBien(_ref23, data) {
      var commit = _ref23.commit,
          state = _ref23.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    countDanhSachThanhToan: function countDanhSachThanhToan(_ref24, data) {
      var commit = _ref24.commit,
          state = _ref24.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDsHangHoa: function loadDsHangHoa(_ref25, data) {
      var commit = _ref25.commit,
          state = _ref25.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['getVmaScheduleCargolistURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDsNeoDau: function loadDsNeoDau(_ref26, data) {
      var commit = _ref26.commit,
          state = _ref26.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['getVmaScheduleAnchorage_Port_URL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDanhSachTauBien: function loadDanhSachTauBien(_ref27, data) {
      var commit = _ref27.commit,
          state = _ref27.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          if (data['getShip']) {
            param['timeout'] = 35000;
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    dsTBPTauBien: function dsTBPTauBien(_ref28, data) {
      var commit = _ref28.commit,
          state = _ref28.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          if (!data) {
            data = {};
          }
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['dsTBPTauBienURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    dsTBPPTTND: function dsTBPPTTND(_ref29, data) {
      var commit = _ref29.commit,
          state = _ref29.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          if (!data) {
            data = {};
          }
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['dsTBPPTTNDURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDanhSachThanhToan: function loadDanhSachThanhToan(_ref30, data) {
      var commit = _ref30.commit,
          state = _ref30.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadHoSoChuyenTau: function loadHoSoChuyenTau(_ref31, data) {
      var commit = _ref31.commit,
          state = _ref31.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['findVmaItineraryScheduleByItineraryNoURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    findUserPortByUserId: function findUserPortByUserId(_ref32, data) {
      var commit = _ref32.commit,
          state = _ref32.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['findUserPortByUserIdURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadInitDepartmentCode: function loadInitDepartmentCode(_ref33, data) {
      var commit = _ref33.commit,
          state = _ref33.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['getDepartmentCodeByUserId'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDsTauVao: function loadDsTauVao(_ref34, data) {
      var commit = _ref34.commit,
          state = _ref34.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['dsNoiChuyenURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDsTauRoi: function loadDsTauRoi(_ref35, data) {
      var commit = _ref35.commit,
          state = _ref35.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['findVmaItineraryScheduleURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDsTempDocument: function loadDsTempDocument(_ref36, data) {
      var commit = _ref36.commit,
          state = _ref36.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['findTempDocumentURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    inPhieuThanhToan: function inPhieuThanhToan(_ref37, data) {
      var commit = _ref37.commit,
          state = _ref37.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.excelBienLaiThuPhi, param).then(function (response) {
            resolve(response.data);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    exportDanhSachTauBien: function exportDanhSachTauBien(_ref38, data) {
      var commit = _ref38.commit,
          state = _ref38.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var url = window.URL.createObjectURL(response.data);
            resolve({
              url: url,
              fileName: response.headers['file-name']
            });
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    exportDanhSachThanhToan: function exportDanhSachThanhToan(_ref39, data) {
      var commit = _ref39.commit,
          state = _ref39.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var urlRequest = data.url;
          var query = {};
          for (var key in data) {
            if (key !== 'url') {
              query[key] = data[key];
            }
          }
          var param = {
            params: query,
            responseType: 'blob'
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(urlRequest, param).then(function (response) {
            var url = window.URL.createObjectURL(response.data);
            resolve({
              url: url,
              fileName: response.headers['file-name']
            });
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadLenhDieuDongEXT: function loadLenhDieuDongEXT(_ref40, data) {
      var commit = _ref40.commit,
          state = _ref40.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getLenhDieuDongEXT, param).then(function (response) {
            var serializable = response.data;
            console.log(serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadHomeDataPaymentTable: function loadHomeDataPaymentTable(_ref41, data) {
      var commit = _ref41.commit,
          state = _ref41.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          var url = '';
          if (result['user'] && result['user'].isKeToan) {
            url = state.initData.getPaymentData;
          } else {
            url = state.initData.getPaymentDataPublicURL;
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, param).then(function (response) {
            var serializable = response.data;
            console.log(serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDocTypes: function loadDocTypes(_ref42) {
      var commit = _ref42.commit,
          state = _ref42.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDocTypes).then(function (response) {
            var serializable = response.data;
            commit('setDocTypes', serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadRoleFilterStatus: function loadRoleFilterStatus(_ref43, filter) {
      var commit = _ref43.commit,
          state = _ref43.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              documentType: filter.documentType
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getRoleFilterStatus, param).then(function (response) {
            var serializable = response.data;
            commit('setRoleFilterStatus', serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailGiuTau: function loadDetailGiuTau(_ref44, filter) {
      var commit = _ref44.commit,
          state = _ref44.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleSecurityId': filter.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleSecurity_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailHaXuong: function loadDetailHaXuong(_ref45, filter) {
      var commit = _ref45.commit,
          state = _ref45.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleLaunchingId': filter.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleLaunching_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailChuyenTuyen: function loadDetailChuyenTuyen(_ref46, filter) {
      var commit = _ref46.commit,
          state = _ref46.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleXlineSailingId': filter.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleXlineSailing_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getVmaitineraryRemarks: function getVmaitineraryRemarks(_ref47, filter) {
      var commit = _ref47.commit,
          state = _ref47.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: filter
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaitineraryRemarksURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailSuaChua: function loadDetailSuaChua(_ref48, filter) {
      var commit = _ref48.commit,
          state = _ref48.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleShipyardId': filter.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleShipyard_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailHoSo: function loadDetailHoSo(_ref49, filter) {
      var commit = _ref49.commit,
          state = _ref49.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentType': filter.documentType,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear,
              'type': filter.type
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDetailByDocumentName, param).then(function (response) {
            var serializable = response.data;
            commit('setDetailHs', serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            commit('setDetailHs', null);
            reject(error);
          });
        });
      });
    },
    loadFlagStateOfShip: function loadFlagStateOfShip(_ref50, data) {
      var commit = _ref50.commit,
          state = _ref50.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getFlagStateOfShip, {}).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadShipOwner: function loadShipOwner(_ref51, data) {
      var commit = _ref51.commit,
          state = _ref51.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getShipOwner, {}).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDataItems: function loadDataItems(_ref52, data) {
      var commit = _ref52.commit,
          state = _ref52.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDataItems, param).then(function (response) {
            var serializable = response.data['data'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDataDm: function loadDataDm(_ref53, data) {
      var commit = _ref53.commit,
          state = _ref53.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          if (data.hasOwnProperty('portOfAuthority') && !data['portOfAuthority'] || data.hasOwnProperty('portofAuthority') && !data['portofAuthority']) {
            param.params['portOfAuthority'] = state.maritimeCode;
            param.params['portofAuthority'] = state.maritimeCode;
          }
          if (data.hasOwnProperty('maritimeCode') && !data['maritimeCode']) {
            param.params['maritimeCode'] = state.maritimeCode;
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDetailDmCategories, param).then(function (response) {
            var serializable = response.data['data'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getDmGtReportCategories: function getDmGtReportCategories(_ref54, data) {
      var commit = _ref54.commit,
          state = _ref54.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['getDmGtReportCategoriesURL'], param).then(function (response) {
            var serializable = response['data'];
            if (serializable['data']) {
              resolve(serializable['data']);
            } else {
              resolve([]);
            }
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    checkHistoryTempDebitnote: function checkHistoryTempDebitnote(_ref55, data) {
      var commit = _ref55.commit,
          state = _ref55.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['checkHistoryTempDebitnoteURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xacBaoTinhPhiTauDichVu: function xacBaoTinhPhiTauDichVu(_ref56, data) {
      var commit = _ref56.commit,
          state = _ref56.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xacBaoTinhPhiTauDichVuURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xacBaoTinhPhiTauChuyenTuyen: function xacBaoTinhPhiTauChuyenTuyen(_ref57, data) {
      var commit = _ref57.commit,
          state = _ref57.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xacBaoTinhPhiTauChuyenTuyenURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xacBaoTinhPhiTauBien_PTTND: function xacBaoTinhPhiTauBien_PTTND(_ref58, data) {
      var commit = _ref58.commit,
          state = _ref58.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xacBaoTinhPhiTauBien_PTTNDURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemBangKeTauDichVu: function xemBangKeTauDichVu(_ref59, data) {
      var commit = _ref59.commit,
          state = _ref59.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xemBangKeTauDichVuURL'], param).then(function (response) {
            var serializable = response.data['url'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemBangChuyenTuyen: function xemBangChuyenTuyen(_ref60, data) {
      var commit = _ref60.commit,
          state = _ref60.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['xemBangKeTauChuyenTuyenURL'], param).then(function (response) {
            var serializable = response.data['url'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xemGiayBaoTinhPhi: function xemGiayBaoTinhPhi(_ref61, data) {
      var commit = _ref61.commit,
          state = _ref61.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['phieuBaoThuPhiURL'], param).then(function (response) {
            var serializable = response.data['url'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDataTugboat: function loadDataTugboat(_ref62, data) {
      var commit = _ref62.commit,
          state = _ref62.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {
            categoryId: 'DM_VMA_TUGBOAT'
          }
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          if (data.hasOwnProperty('portOfAuthority') && !data['portOfAuthority'] || data.hasOwnProperty('portofAuthority') && !data['portofAuthority']) {
            param.params['portOfAuthority'] = state.maritimeCode;
            param.params['portofAuthority'] = state.maritimeCode;
          }
          if (data.hasOwnProperty('maritimeCode') && !data['maritimeCode']) {
            param.params['maritimeCode'] = state.maritimeCode;
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDetailDmCategories, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDataDmSync: function loadDataDmSync(_ref63, data) {
      var commit = _ref63.commit,
          state = _ref63.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDmSyncCategories, param).then(function (response) {
            var serializable = response.data['data'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDataDmDetail: function loadDataDmDetail(_ref64, data) {
      var commit = _ref64.commit,
          state = _ref64.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: {}
        };
        for (var key in data) {
          param.params[key] = data[key];
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDetail, param).then(function (response) {
            var serializable = response.data['data'];
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadChanelList: function loadChanelList(_ref65, data) {
      var commit = _ref65.commit,
          state = _ref65.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getDetailDmCategories, {
            params: {
              categoryId: 'DM_TUYEN_LUONG'
            }
          }).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailTauBien: function loadDetailTauBien(_ref66, data) {
      var commit = _ref66.commit,
          state = _ref66.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaShipId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaShip_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailPTTND: function loadDetailPTTND(_ref67, data) {
      var commit = _ref67.commit,
          state = _ref67.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaShipId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaShip_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailHoaTieuDanTauFromItinerary: function loadDetailHoaTieuDanTauFromItinerary(_ref68, data) {
      var commit = _ref68.commit,
          state = _ref68.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
              start: 0,
              end: 15
            }, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaSchedulePilotURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailNhapTachDoanFromItinerary: function loadDetailNhapTachDoanFromItinerary(_ref69, data) {
      var commit = _ref69.commit,
          state = _ref69.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
              start: 0,
              end: 15
            }, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleMergingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailNhapTachDoan: function loadDetailNhapTachDoan(_ref70, data) {
      var commit = _ref70.commit,
          state = _ref70.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleMergingId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleMerging_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailHoaTieuDanTau: function loadDetailHoaTieuDanTau(_ref71, data) {
      var commit = _ref71.commit,
          state = _ref71.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaSchedulePilotId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaSchedulePilot_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailTauNeoDau: function loadDetailTauNeoDau(_ref72, data) {
      var commit = _ref72.commit,
          state = _ref72.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleAnchorageId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleAnchorage_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetail_PTTND: function loadDetail_PTTND(_ref73, data) {
      var commit = _ref73.commit,
          state = _ref73.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailTauDenCang: function loadDetailTauDenCang(_ref74, data) {
      var commit = _ref74.commit,
          state = _ref74.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailFromItineraryNo_NoticeShipType: function loadDetailFromItineraryNo_NoticeShipType(_ref75, data) {
      var commit = _ref75.commit,
          state = _ref75.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          console.log('state.initData+++++++++++++', state.initData);
          var param = {
            params: {
              'itineraryNo': data['itineraryNo'],
              'noticeShipType': data['noticeShipType']
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItinerary_ItineraryNo_NoticeShipTypeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailThuTau: function loadDetailThuTau(_ref76, data) {
      var commit = _ref76.commit,
          state = _ref76.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleTestingId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleTesting_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailTauDiChuyen: function loadDetailTauDiChuyen(_ref77, data) {
      var commit = _ref77.commit,
          state = _ref77.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleShiftingId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleShifting_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadListNhapTachDoanFromItinerary: function loadListNhapTachDoanFromItinerary(_ref78, data) {
      var commit = _ref78.commit,
          state = _ref78.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
              start: 0,
              end: 15
            }, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleMergingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetaiTauLaiHoTroFromItinerary: function loadDetaiTauLaiHoTroFromItinerary(_ref79, data) {
      var commit = _ref79.commit,
          state = _ref79.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
              start: 0,
              end: 15
            }, data)
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleTugboatListURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetaiTauLaiHoTro: function loadDetaiTauLaiHoTro(_ref80, data) {
      var commit = _ref80.commit,
          state = _ref80.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleTugboatId': data.id,
              'documentType': data.documentType,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleTugboat_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailKhangCao: function loadDetailKhangCao(_ref81, data) {
      var commit = _ref81.commit,
          state = _ref81.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaItineraryProtestId': data.id,
              'documentName': data.documentName,
              'documentYear': data.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItineraryProtest_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetaiHangHoaXepDo: function loadDetaiHangHoaXepDo(_ref82, data) {
      var commit = _ref82.commit,
          state = _ref82.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaScheduleCargolistId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaScheduleCargolist_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailTauRoiCang: function loadDetailTauRoiCang(_ref83, data) {
      var commit = _ref83.commit,
          state = _ref83.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'vmaItineraryScheduleId': data.id
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItinerarySchedule_Detail_URL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauChuyenTuyen: function deleteTauChuyenTuyen(_ref84, data) {
      var commit = _ref84.commit,
          state = _ref84.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleXlineSailingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteNhapTachDoan: function deleteNhapTachDoan(_ref85, data) {
      var commit = _ref85.commit,
          state = _ref85.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteScheduleMergingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteKhangCao: function deleteKhangCao(_ref86, data) {
      var commit = _ref86.commit,
          state = _ref86.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaItineraryProtestURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauLaiHoTro: function deleteTauLaiHoTro(_ref87, data) {
      var commit = _ref87.commit,
          state = _ref87.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleTugboatURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteThuTau: function deleteThuTau(_ref88, data) {
      var commit = _ref88.commit,
          state = _ref88.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleTestingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteGiuTau: function deleteGiuTau(_ref89, data) {
      var commit = _ref89.commit,
          state = _ref89.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleSecurityURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteThaXuong: function deleteThaXuong(_ref90, data) {
      var commit = _ref90.commit,
          state = _ref90.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleLaunchingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauDiChuyen: function deleteTauDiChuyen(_ref91, data) {
      var commit = _ref91.commit,
          state = _ref91.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleShiftingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauDenCang: function deleteTauDenCang(_ref92, data) {
      var commit = _ref92.commit,
          state = _ref92.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addVmaItinerary: function addVmaItinerary(_ref93, data) {
      var commit = _ref93.commit,
          state = _ref93.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaItineraryURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addHangHoaXD: function addHangHoaXD(_ref94, data) {
      var commit = _ref94.commit,
          state = _ref94.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleCargolistURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addKhangCao: function addKhangCao(_ref95, data) {
      var commit = _ref95.commit,
          state = _ref95.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaItineraryProtestURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addThaXuong: function addThaXuong(_ref96, data) {
      var commit = _ref96.commit,
          state = _ref96.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleLaunchingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addPTTNDTauDenCang: function addPTTNDTauDenCang(_ref97, data) {
      var commit = _ref97.commit,
          state = _ref97.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addPTTNDTauDenCang, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauBien: function addTauBien(_ref98, data) {
      var commit = _ref98.commit,
          state = _ref98.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          console.log('state.initData.addVmaShipURL++++++++++', state.initData.addVmaShipURL);
          var param = {
            params: data,
            headers: {}
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaShipURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauBien: function deleteTauBien(_ref99, data) {
      var commit = _ref99.commit,
          state = _ref99.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data,
            headers: {}
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteTauBien, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateAnchorageListPayment: function updateAnchorageListPayment(_ref100, data) {
      var commit = _ref100.commit,
          state = _ref100.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateAnchorageListPaymentURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateCargolistListPayment: function updateCargolistListPayment(_ref101, data) {
      var commit = _ref101.commit,
          state = _ref101.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateCargolistListPaymentURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateProtestListPayment: function updateProtestListPayment(_ref102, data) {
      var commit = _ref102.commit,
          state = _ref102.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateProtestListPaymentURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateShipPosition: function updateShipPosition(_ref103, data) {
      var commit = _ref103.commit,
          state = _ref103.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateShipPositionURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editKhangCao: function editKhangCao(_ref104, data) {
      var commit = _ref104.commit,
          state = _ref104.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['updateVmaItineraryProtestURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editTauNeoDau: function editTauNeoDau(_ref105, data) {
      var commit = _ref105.commit,
          state = _ref105.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleAnchorageURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editGiuTau: function editGiuTau(_ref106, data) {
      var commit = _ref106.commit,
          state = _ref106.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleSecurityURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editThaXuong: function editThaXuong(_ref107, data) {
      var commit = _ref107.commit,
          state = _ref107.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleLaunchingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editSuaChua: function editSuaChua(_ref108, data) {
      var commit = _ref108.commit,
          state = _ref108.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleShipyardURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editNhapTachToan: function editNhapTachToan(_ref109, data) {
      var commit = _ref109.commit,
          state = _ref109.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateScheduleMergingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editHoaTieuDanTau: function editHoaTieuDanTau(_ref110, data) {
      var commit = _ref110.commit,
          state = _ref110.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaSchedulePilotURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editHangHoaXD: function editHangHoaXD(_ref111, data) {
      var commit = _ref111.commit,
          state = _ref111.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleCargolistURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getVmaTransactionFunction: function getVmaTransactionFunction(_ref112, data) {
      var commit = _ref112.commit,
          state = _ref112.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaTransactionFunctionURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    actionKeHoachAllInOne: function actionKeHoachAllInOne(_ref113, data) {
      var commit = _ref113.commit,
          state = _ref113.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.actionKeHoachAllInOneURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getFileThanhPhanVersionList: function getFileThanhPhanVersionList(_ref114, data) {
      var commit = _ref114.commit,
          state = _ref114.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getFileThanhPhanVersionList, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getVmaConversionData: function getVmaConversionData(_ref115, data) {
      var commit = _ref115.commit,
          state = _ref115.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaConversionDataURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getVmaTransactionSlipDetail: function getVmaTransactionSlipDetail(_ref116, data) {
      var commit = _ref116.commit,
          state = _ref116.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addVmaTransactionSlipDetail: function addVmaTransactionSlipDetail(_ref117, data) {
      var commit = _ref117.commit,
          state = _ref117.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateVmaTransactionSlipDetail: function updateVmaTransactionSlipDetail(_ref118, data) {
      var commit = _ref118.commit,
          state = _ref118.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editTauLaiHoTro: function editTauLaiHoTro(_ref119, data) {
      var commit = _ref119.commit,
          state = _ref119.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleTugboatURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    tinhPhiLaiTauDichVu: function tinhPhiLaiTauDichVu(_ref120, data) {
      var commit = _ref120.commit,
          state = _ref120.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['huyBaoTinhPhiDichVuURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    tinhPhiLaiTauChuyenTuyen: function tinhPhiLaiTauChuyenTuyen(_ref121, data) {
      var commit = _ref121.commit,
          state = _ref121.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['huyBaoTinhPhiChuyenTuyenURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    huytinhphi: function huytinhphi(_ref122, data) {
      var commit = _ref122.commit,
          state = _ref122.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['huytinhphiURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    huyTinhPhiTauDichVu: function huyTinhPhiTauDichVu(_ref123, data) {
      var commit = _ref123.commit,
          state = _ref123.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['huyBaoTinhPhiDichVuURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    huyTinhPhiTauChuyenTuyen: function huyTinhPhiTauChuyenTuyen(_ref124, data) {
      var commit = _ref124.commit,
          state = _ref124.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData['huyBaoTinhPhiChuyenTuyenURL'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    capNhatListKhangNghi: function capNhatListKhangNghi(_ref125, data) {
      var commit = _ref125.commit,
          state = _ref125.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleProtest_MakePayment_DocumentaryCodeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    capNhatListHangHoa: function capNhatListHangHoa(_ref126, data) {
      var commit = _ref126.commit,
          state = _ref126.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleCargolist_MakePayment_DocumentaryCodeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    capNhatListNeo: function capNhatListNeo(_ref127, data) {
      var commit = _ref127.commit,
          state = _ref127.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleAnchoragePortURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xacnhantinhphi: function xacnhantinhphi(_ref128, data) {
      var commit = _ref128.commit,
          state = _ref128.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.xacnhantinhphiURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    sotienphainop: function sotienphainop(_ref129, data) {
      var commit = _ref129.commit,
          state = _ref129.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.sotienphainopURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    xacnhanthanhtoan: function xacnhanthanhtoan(_ref130, data) {
      var commit = _ref130.commit,
          state = _ref130.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.xacnhanthanhtoanURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    nopTien: function nopTien(_ref131, data) {
      var commit = _ref131.commit,
          state = _ref131.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.noptienURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    rutquy: function rutquy(_ref132, data) {
      var commit = _ref132.commit,
          state = _ref132.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.rutquyURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    napquy_dunodauky: function napquy_dunodauky(_ref133, data) {
      var commit = _ref133.commit,
          state = _ref133.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.napquy_dunodaukyURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editTauBien: function editTauBien(_ref134, data) {
      var commit = _ref134.commit,
          state = _ref134.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaShipURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteHangHoaXD: function deleteHangHoaXD(_ref135, data) {
      var commit = _ref135.commit,
          state = _ref135.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleCargolistURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteHoaTieuDanTau: function deleteHoaTieuDanTau(_ref136, data) {
      var commit = _ref136.commit,
          state = _ref136.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaSchedulePilotURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauRoiCang: function deleteTauRoiCang(_ref137, data) {
      var commit = _ref137.commit,
          state = _ref137.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteTauNeoDau: function deleteTauNeoDau(_ref138, data) {
      var commit = _ref138.commit,
          state = _ref138.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleAnchorageURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deletePTTNDTauDenCang: function deletePTTNDTauDenCang(_ref139, data) {
      var commit = _ref139.commit,
          state = _ref139.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteSuaChua: function deleteSuaChua(_ref140, data) {
      var commit = _ref140.commit,
          state = _ref140.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaScheduleShipyardURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deletePTTNDTauRoiCang: function deletePTTNDTauRoiCang(_ref141, data) {
      var commit = _ref141.commit,
          state = _ref141.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deleteVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deletePhuongTienThuyNoiDia: function deletePhuongTienThuyNoiDia(_ref142, data) {
      var commit = _ref142.commit,
          state = _ref142.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.deletePhuongTienThuyNoiDia, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editPhuongTienThuyNoiDia: function editPhuongTienThuyNoiDia(_ref143, data) {
      var commit = _ref143.commit,
          state = _ref143.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaShipURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addPhuongTienThuyNoiDia: function addPhuongTienThuyNoiDia(_ref144, data) {
      var commit = _ref144.commit,
          state = _ref144.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data,
            headers: {}
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaShipURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addGiuTau: function addGiuTau(_ref145, data) {
      var commit = _ref145.commit,
          state = _ref145.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleSecurityURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addSuaChua: function addSuaChua(_ref146, data) {
      var commit = _ref146.commit,
          state = _ref146.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleShipyardURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauChuyenTuyen: function addTauChuyenTuyen(_ref147, data) {
      var commit = _ref147.commit,
          state = _ref147.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('chanelCodeList+++++++++++', data);
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleXlineSailingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addThuTau: function addThuTau(_ref148, data) {
      var commit = _ref148.commit,
          state = _ref148.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        console.log('chanelCodeList+++++++++++', data);
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleTestingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauDiChuyen: function addTauDiChuyen(_ref149, data) {
      var commit = _ref149.commit,
          state = _ref149.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        console.log('chanelCodeList+++++++++++', data);
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleShiftingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editTauChuyenTuyen: function editTauChuyenTuyen(_ref150, data) {
      var commit = _ref150.commit,
          state = _ref150.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleXlineSailingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editThuTau: function editThuTau(_ref151, data) {
      var commit = _ref151.commit,
          state = _ref151.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleTestingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    editTauDiChuyen: function editTauDiChuyen(_ref152, data) {
      var commit = _ref152.commit,
          state = _ref152.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaScheduleShiftingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauRoiCang: function addTauRoiCang(_ref153, data) {
      var commit = _ref153.commit,
          state = _ref153.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addTauRoiCang, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauNeoDau: function addTauNeoDau(_ref154, data) {
      var commit = _ref154.commit,
          state = _ref154.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleAnchorageURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addTauLaiHoTro: function addTauLaiHoTro(_ref155, data) {
      var commit = _ref155.commit,
          state = _ref155.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaScheduleTugboatURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addNhapTachDoan: function addNhapTachDoan(_ref156, data) {
      var commit = _ref156.commit,
          state = _ref156.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addScheduleMergingURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addHoaTieuDanTau: function addHoaTieuDanTau(_ref157, data) {
      var commit = _ref157.commit,
          state = _ref157.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaSchedulePilotURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    autoFillCargolist: function autoFillCargolist(_ref158, data) {
      var commit = _ref158.commit,
          state = _ref158.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.autoFillCargolistURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addVmaItinerarySchedule: function addVmaItinerarySchedule(_ref159, data) {
      var commit = _ref159.commit,
          state = _ref159.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        console.log('data +++++++++++++', data);
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateVmaItinerary: function updateVmaItinerary(_ref160, data) {
      var commit = _ref160.commit,
          state = _ref160.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaItineraryURL, param).then(function (response) {
            var serializable = response.data;
            commit('setItineraryNo', serializable);
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    addPhieuThanhToan: function addPhieuThanhToan(_ref161, data) {
      var commit = _ref161.commit,
          state = _ref161.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.addVmaTransactionSlip_VmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updatePhieuThanhToan: function updatePhieuThanhToan(_ref162, data) {
      var commit = _ref162.commit,
          state = _ref162.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaTransactionSlip_VmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailPhiById: function loadDetailPhiById(_ref163, data) {
      var commit = _ref163.commit,
          state = _ref163.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaTransactionSlipDetailURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadDetailPhi: function loadDetailPhi(_ref164, data) {
      var commit = _ref164.commit,
          state = _ref164.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.findVmaTransactionSlipByItineraryNoDocumenttaryCodeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    tinhPhi: function tinhPhi(_ref165, data) {
      var commit = _ref165.commit,
          state = _ref165.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var param = {
          params: data,
          headers: {}
        };
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.doChargeURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    updateVmaItinerarySchedule: function updateVmaItinerarySchedule(_ref166, data) {
      var commit = _ref166.commit,
          state = _ref166.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var chanelCodeList = '';
        console.log('data +++++++++++++', data);
        var param = {
          params: data,
          headers: {}
        };
        if (data.hasOwnProperty('chanelCodeList') && data['chanelCodeList']) {
          if (Array.isArray(data['chanelCodeList'])) {
            chanelCodeList = data['chanelCodeList'].join();
            param.params['chanelCodeList'] = chanelCodeList;
          }
        }
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.updateVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    deleteItemTable: function deleteItemTable(_ref167, data) {
      var commit = _ref167.commit,
          state = _ref167.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          for (var key in data) {
            if (key !== 'url') {
              param.params[key] = data[key];
            }
          }
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(data['url'], param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadKhaiBaoHoSo: function loadKhaiBaoHoSo(_ref168, filter) {
      var commit = _ref168.commit,
          state = _ref168.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getThongTinKhaiBaoTable, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getCheckActiveVma: function getCheckActiveVma(_ref169, filter) {
      var commit = _ref169.commit,
          state = _ref169.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.checkActiveVmaURL, {}).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadItineraryFromItineraryNo: function loadItineraryFromItineraryNo(_ref170, filter) {
      var commit = _ref170.commit,
          state = _ref170.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: filter
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItineraryByItineraryNoURL, param).then(function (response) {
            var serializable = response.data;

            if (serializable.hasOwnProperty('itineraryNo')) {
              commit('setItineraryNo', serializable);
            } else {
              commit('setItineraryNo', {});
            }
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            commit('setItineraryNo', {});
            reject(error);
          });
        });
      });
    },
    loadItineraryNo: function loadItineraryNo(_ref171, filter) {
      var commit = _ref171.commit,
          state = _ref171.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getVmaItineraryNoURL, param).then(function (response) {
            var serializable = response.data;

            if (serializable.hasOwnProperty('itineraryNo')) {
              commit('setItineraryNo', serializable);
            } else {
              commit('setItineraryNo', {});
            }
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            commit('setItineraryNo', {});
            reject(error);
          });
        });
      });
    },
    loadInitData: function loadInitData(_ref172, filter) {
      var commit = _ref172.commit,
          state = _ref172.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          if (!state.itineraryNo) {
            store.dispatch('loadItineraryNo', {
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }).then(function (resultItineraryNo) {
              var param = {
                params: {
                  'itineraryNo': resultItineraryNo.hasOwnProperty('itineraryNo') ? resultItineraryNo['itineraryNo'] : '',
                  'documentName': filter.documentName,
                  'documentYear': filter.documentYear
                }
              };
              __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.setVmaInitScheduleURL, param).then(function (response) {
                var serializable = response.data;
                resolve(serializable);
              }).catch(function (error) {
                console.log(error);
                reject(error);
              });
            });
          } else {
            var param = {
              params: {
                'itineraryNo': state.itineraryNo ? state.itineraryNo['itineraryNo'] : '',
                'documentName': filter.documentName,
                'documentYear': filter.documentYear
              }
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.setVmaInitScheduleURL, param).then(function (response) {
              var serializable = response.data;
              resolve(serializable);
            }).catch(function (error) {
              console.log(error);
              reject(error);
            });
          }
        });
      });
    },
    getExchangeRate: function getExchangeRate(_ref173, data) {
      var commit = _ref173.commit,
          state = _ref173.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getTyGiaURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getLastVmaItinerarySchedule: function getLastVmaItinerarySchedule(_ref174, data) {
      var commit = _ref174.commit,
          state = _ref174.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: data
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getLastVmaItineraryScheduleURL, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadMessageType23EXT: function loadMessageType23EXT(_ref175, filter) {
      var commit = _ref175.commit,
          state = _ref175.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getMessageType23EXT, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadPhanHoi: function loadPhanHoi(_ref176, filter) {
      var commit = _ref176.commit,
          state = _ref176.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getPhanHoiTuCoQuanChuyenNganhTable, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadGhiChu: function loadGhiChu(_ref177, filter) {
      var commit = _ref177.commit,
          state = _ref177.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentName': filter.maBanKhai,
              'documentYear': filter.documentYear,
              'ministryCode': filter.ministryCode
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.exportPDFDetail, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    loadUserSigns: function loadUserSigns(_ref178, filter) {
      var commit = _ref178.commit,
          state = _ref178.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'documentType': filter.documentType,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear,
              'messageType': filter.messageType,
              'REQUEST_CODE': filter.requestCode,
              'roleType': filter.roleType
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.checkThanhPhanActionButton, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getListPortWharf: function getListPortWharf(_ref179, filter) {
      var commit = _ref179.commit,
          state = _ref179.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          var param = {
            params: {
              'harbourCode': filter.harbourCode,
              'documentName': filter.documentName,
              'documentYear': filter.documentYear
            }
          };
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getListPortWharf, param).then(function (response) {
            var serializable = response.data;
            resolve(serializable);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    },
    getTinMois: function getTinMois(_ref180) {
      var commit = _ref180.commit,
          state = _ref180.state;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(state.initData.getNotifications).then(function (response) {
            var serializable = response.data;
            resolve(serializable.data);
          }).catch(function (error) {
            console.log(error);
            reject(error);
          });
        });
      });
    }
  },
  mutations: {
    setDrawer: function setDrawer(state, payload) {
      state.drawer = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setLoadingTable: function setLoadingTable(state, payload) {
      state.loadingTable = payload;
    },
    setLoadingSubmit: function setLoadingSubmit(state, payload) {
      state.loadingSubmit = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    setInitData: function setInitData(state, payload) {
      state.initData = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setCounterThongBaoPhi: function setCounterThongBaoPhi(state, payload) {
      state.counterThongBaoPhi = payload;
    },
    setCounterDaXuLy: function setCounterDaXuLy(state, payload) {
      state.counterDaXuLy = payload;
    },
    setDocTypes: function setDocTypes(state, payload) {
      state.docTypes = payload;
    },
    setRoleFilterStatus: function setRoleFilterStatus(state, payload) {
      state.roleFilterStatus = payload;
    },
    setOtherData: function setOtherData(state, payload) {
      state.otherData = payload;
    },
    setItineraryNo: function setItineraryNo(state, payload) {
      window.sessionStorage.setItem('itineraryNo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.itineraryNo = payload;
    },
    setDetailHs: function setDetailHs(state, payload) {
      state.detailHs = payload;
    },
    setMaritimeCode: function setMaritimeCode(state, payload) {
      state.maritimeCode = payload;
    },
    totalTauDiChuyen: function totalTauDiChuyen(state, payload) {
      window.sessionStorage.setItem('totalTauDiChuyen', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.totalTauDiChuyen = payload;
    },
    setItemFee: function setItemFee(state, payload) {
      window.sessionStorage.setItem('itemFee', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.itemFee = payload;
    },
    setSelectTau: function setSelectTau(state, payload) {
      window.sessionStorage.setItem('selectTau', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.selectTau = payload;
    },
    setSelectTauRoi: function setSelectTauRoi(state, payload) {
      window.sessionStorage.setItem('selectTauRoi', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.selectTauRoi = payload;
    },
    setKeHoachDen: function setKeHoachDen(state, payload) {
      window.sessionStorage.setItem('keHoachDen', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload));
      state.keHoachDen = payload;
    },
    setPttnd: function setPttnd(state, payload) {
      window.sessionStorage.setItem('pttnd', payload);
      state.pttnd = payload;
    },
    setSelectPTTND: function setSelectPTTND(state, payload) {
      state.selectPTTND = payload;
    },
    setSwitch1: function setSwitch1(state, payload) {
      state.switch1 = payload;
    },
    setNoiChuyenlai: function setNoiChuyenlai(state, payload) {
      state.noiChuyenlai = payload;
    }
  },
  getters: {
    initData: function initData(state) {
      return state.initData;
    },
    loading: function loading(state) {
      return state.loading;
    },
    itineraryNo: function itineraryNo(state) {
      var item = state.itineraryNo;
      if (item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length !== 0 && item.constructor === Object) {
        return item;
      } else {
        item = window.sessionStorage.getItem('itineraryNo');
        if (item && item !== 'null') {
          try {
            item = JSON.parse(item);
            return item || {};
          } catch (e) {
            item = {};
            console.log(e);
          }
        } else {
          item = {};
        }
      }
      return item;
    },
    loadingTable: function loadingTable(state) {
      return state.loadingTable;
    },
    loadingSubmit: function loadingSubmit(state) {
      return state.loadingSubmit;
    },
    loadingInitData: function loadingInitData(state) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('loadInitResource').then(function (result) {
          resolve(result);
        });
      });
    },
    selectTau: function selectTau(state) {
      var item = state.selectTau;
      if (item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length !== 0 && item.constructor === Object) {
        return item;
      } else {
        item = window.sessionStorage.getItem('selectTau');
        if (item) {
          try {
            item = JSON.parse(item);
            return item || {};
          } catch (e) {
            item = {};
            console.log(e);
          }
        }
      }
      return item;
    },
    itemFee: function itemFee(state) {
      var item = state.itemFee;
      if (item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length !== 0 && item.constructor === Object) {
        return item;
      } else {
        item = window.sessionStorage.getItem('itemFee');
        if (item) {
          try {
            item = JSON.parse(item);
            return item || {};
          } catch (e) {
            item = {};
            console.log(e);
          }
        } else {
          item = {};
        }
      }
      return item;
    },
    keHoachDen: function keHoachDen(state) {
      var item = state.keHoachDen;
      if (item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length !== 0 && item.constructor === Object) {
        return item;
      } else {
        item = window.sessionStorage.getItem('keHoachDen');
        if (item) {
          try {
            item = JSON.parse(item);
            return item || {};
          } catch (e) {
            item = {};
            console.log(e);
          }
        }
      }
      return item;
    },
    selectTauRoi: function selectTauRoi(state) {
      var item = state.selectTauRoi;
      if (item && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).length !== 0 && item.constructor === Object) {
        return item;
      } else {
        item = window.sessionStorage.getItem('selectTauRoi');
        if (item) {
          try {
            item = JSON.parse(item);
            return item || {};
          } catch (e) {
            item = {};
            console.log(e);
          }
        }
      }
      return item;
    },
    pttnd: function pttnd(state) {
      var item = window.sessionStorage.getItem('pttnd') === 'true';
      if (item === null || item === undefined || item === '' || item === 'undefined') {
        return false;
      }
      return item;
    },
    totalTauDiChuyen: function totalTauDiChuyen(state) {
      var item = state.totalTauDiChuyen;
      if (!item) {
        return item;
      } else {
        item = window.sessionStorage.getItem('totalTauDiChuyen');
        item = parseInt(item);
      }
      return item;
    },
    selectPTTND: function selectPTTND(state) {
      return state.selectPTTND;
    },
    error: function error(state) {
      return state.error;
    },
    index: function index(state) {
      return state.index;
    },
    docTypes: function docTypes(state) {
      if (state.docTypes === null) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          store.dispatch('loadDocTypes').then(function (result) {
            resolve(result);
          });
        });
      } else {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          resolve(state.docTypes);
        });
      }
    },
    switch1: function switch1(state) {
      return state.switch1;
    },
    otherData: function otherData(state) {
      return state.otherData;
    },
    roleFilterStatus: function roleFilterStatus(state) {
      return function (filter) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          store.dispatch('loadRoleFilterStatus', filter).then(function (result) {
            resolve(result);
          });
        });
      };
    },
    counterThongBaoPhi: function counterThongBaoPhi(state) {
      return state.counterThongBaoPhi;
    },
    counterDaXuLy: function counterDaXuLy(state) {
      return state.counterDaXuLy;
    },
    detailHs: function detailHs(state) {
      return state.detailHs;
    },
    drawer: function drawer(state) {
      return state['drawer'];
    },
    noiChuyenlai: function noiChuyenlai(state) {
      return state['noiChuyenlai'];
    },
    maritimeCode: function maritimeCode(state) {
      return state['maritimeCode'];
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr_build_toastr_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_content_placeholders__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_moment__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_datetime_2__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_datetime_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_datetime_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_bus_eventBus__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_dialog__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuejs_dialog_dist_vuejs_dialog_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_currency_field__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_currency_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_v_currency_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_currency_field_dist_index_css__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_v_currency_field_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_v_currency_field_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_good_table__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css__);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return __WEBPACK_IMPORTED_MODULE_11__event_bus_eventBus__["default"]; });




















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_datetime_2___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_v_currency_field___default.a);



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app1',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  },
  props: ['type', 'documentTypeCode', 'documentStatusCode'],
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {
      var url = window.location.href;
      var coma = window.location.href.lastIndexOf('#/');
      url = window.location.href.substr(coma, url.length) ? window.location.href.substr(coma, url.length) : '';

      if (url === '#/' || !url) {
        vm.$store.dispatch('loadInitResource').then(function (result) {});
      }
    });
  }
});

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(166);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fab: false,
      tinMois: [],
      initData: null,
      isKeToan: false,
      showDraw: false
    };
  },
  computed: {
    drawer: {
      get: function get() {
        return this.$store.getters.drawer;
      },
      set: function set(val) {
        this.$store.commit('setDrawer', val);
      }
    }
  },
  created: function created() {
    var vm = this;

    vm.$nextTick(function () {});
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      var newtype = newRoute.params.type;
      console.log('newtype', newtype);
      if (vm.initData !== null && vm.initData !== undefined && vm.initData !== 'undefined') {}
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#navigation>ul>li.extend').remove();
  },

  methods: {
    toDetailNoti: function toDetailNoti(item, isKeHoach) {
      if (isKeHoach) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/ho-so/ke_hoach/' + item.documentName + '/' + item.documentYear + '/' + item.documentTypeCode + '/' + item.documentRequestState);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/ho-so/thu_tuc/' + item.documentName + '/' + item.documentYear + '/' + item.documentTypeCode + '/' + item.documentStatusCode);
      }
    }
  }
});

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_support_data_json__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_support_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_support_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ViTriTauTaiCang_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ViTriTauTaiCang_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ViTriTauTaiCang_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_KeHoachDieuDongTau_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_KeHoachDieuDongTau_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_KeHoachDieuDongTau_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_KeHoachDieuDongTau_2_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_KeHoachDieuDongTau_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_KeHoachDieuDongTau_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TauTrongCang_vue__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TauTrongCang_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TauTrongCang_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: '',
    id: ''
  },
  computed: {
    drawer: {
      get: function get() {
        return this.$store.getters.drawer;
      },
      set: function set(val) {
        this.$store.commit('setDrawer', val);
      }
    }
  },
  components: {
    'jx-hanghai-vi-tri-tau-roi-cang': __WEBPACK_IMPORTED_MODULE_2__components_ViTriTauTaiCang_vue___default.a,
    'jx-hanghai-ke-hoach-dieu-dong': __WEBPACK_IMPORTED_MODULE_3__components_KeHoachDieuDongTau_vue___default.a,
    'jx-hanghai-ke-hoach-dieu-dong-2': __WEBPACK_IMPORTED_MODULE_4__components_KeHoachDieuDongTau_2_vue___default.a,
    'jx-hanghai-tau-trong-cang': __WEBPACK_IMPORTED_MODULE_5__components_TauTrongCang_vue___default.a
  },
  data: function data() {
    return {
      docTypes: [],
      roleFilterStatus: [],
      initData: null,
      counterHoSoAll: '',
      counterHoSoKeHoachTable: '',
      counterHoSoThuTucTable: '',
      cang_vu_name: '',
      tau_den_rois: [],
      quoc_tichs: __WEBPACK_IMPORTED_MODULE_1__store_support_data_json___default.a.data_state,
      khu_cuc_cangs: [],
      cang_den_tiep_theos: [],
      callBack: true,
      getFilterADVDataAPI: '',
      showAdv: false,
      stateViewFilterLeft: false,
      maritimeCode: 0
    };
  },
  beforeCreate: function beforeCreate() {
    var vm = this;
    vm.$nextTick(function () {
      vm.$store.dispatch('loadInitResource').then(function (result) {
        vm.initData = result;
        if (vm.initData !== null) {}
      });
    });
  },
  created: function created() {
    var vm = this;
    vm.$nextTick(function () {});
  },
  updated: function updated() {
    var vm = this;
    vm.$nextTick(function () {
      vm.loadMaritimeCode();
    });
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {}
  },
  methods: {
    loadMaritimeCode: function loadMaritimeCode(query) {
      var vm = this;
      var param = {};
      param['isDelete'] = 0;
      param['start'] = -1;
      param['end'] = -1;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0;
            resolve(result[0]);
          } else {
            resolve({});
          }
        }).catch(function (xhr) {
          console.log(xhr);
          reject(false);
        });
      });
    }
  }
});

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_support_json__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {},
  provide: {},
  data: function data() {
    return {
      switch1: false,
      supportData: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a,
      itemsDsTauDenCang: [],
      itemsDsTauRoiCang: [],
      itemsDsTauDiChuyen: [],
      groupOptions: { columns: ['anchoringPortHarbourName'] },
      searchTopTauAll: '',
      menuTopTauAll: false,
      dateSearchTopTauAll: '',
      headersTauDenCang: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a.headersTauDenCang,
      headersTauRoiCang: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a.headersTauRoiCang,
      headersTauDiChuyen: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a.headersKHTauDiChuyen,
      loadingTableTauDen: false,
      loadingTableTauRoi: false,
      loadingTableTauDiChuyen: false,
      maritimeCode: 0
    };
  },
  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.switch1 = true;
      } else {
        vm.switch1 = false;
      }
    },
    dateSearchTopTauAll: function dateSearchTopTauAll(val) {
      this.searchTopTauAll = this.parseDate(val);
      this.loadDataTauDenCang();
      this.loadDataTauRoiCang();
      this.loadDataTauDiChuyen();
    }
  },
  computed: {},
  created: function created() {
    var vm = this;

    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(function (result) {
        vm.getCurentDate();
        if (vm.code === 'KeHoachDieuDongTau2') {
          vm.switch1 = true;
        } else {
          vm.switch1 = false;
        }
      });
    });
  },

  methods: {
    loadMaritimeCode: function loadMaritimeCode(query) {
      var vm = this;
      var param = {};
      param['isDelete'] = 0;
      param['start'] = -1;
      param['end'] = -1;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0;
            resolve(result[0]);
          } else {
            resolve({});
          }
        }).catch(function (xhr) {
          console.log(xhr);
          reject(false);
        });
      });
    },
    changeTypePart: function changeTypePart() {
      var vm = this;
      if (vm.maritimeCode === 18 || vm.maritimeCode === '18') {
        vm.switch1 = !vm.switch1;
      }
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        });
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        });
      }
    },
    toDetailTauDen: function toDetailTauDen(item) {
      var vm = this;
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(function (result) {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameIN'],
          documentYear: result['documentYearIN']
        }).then(function (resultHoSo) {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameIN'] + '/' + result['documentYearIN'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauDenCang/' + item['vmaItineraryScheduleId']
            });
          }
        });
      }).catch(function (xhr) {});
    },
    toDetailTauRoi: function toDetailTauRoi(item) {
      var vm = this;
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(function (result) {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameOUT'],
          documentYear: result['documentYearOUT']
        }).then(function (resultHoSo) {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameOUT'] + '/' + result['documentYearOUT'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauRoiCang/' + item['vmaItineraryScheduleId']
            });
          }
        });
      }).catch(function (xhr) {});
    },
    toDetailTauDiChuyen: function toDetailTauDiChuyen(item) {
      var vm = this;
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(function (result) {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameIN'],
          documentYear: result['documentYearIN']
        }).then(function (resultHoSo) {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameIN'] + '/' + result['documentYearIN'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauDiChuyen/' + item['vmaScheduleShiftingId']
            });
          }
        });
      }).catch(function (xhr) {});
    },
    getCurentDate: function getCurentDate() {
      var date = new Date();
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    mapNameData: function mapNameData(data) {
      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!data || !Array.isArray(data) || !data.length) {
          console.log('no data table!');
          resolve([]);
          return;
        }
        var dmAnchoringPortHarbourCode = [];
        var dmAnchoringPortWharfCode = [];
        var dmShiftingPortHarbourCode = [];
        var dmShiftingPortWharfCode = [];
        var dmShiftingPortRegionCode = [];
        var dmLastPortHarbourCode = [];
        var dmLastPortWharfCode = [];
        var dmLastPortRegionCode = [];
        var dmNextMaritimePortCode = [];
        var dmNextPortRegionCode = [];
        var dmNextPortHarbourCode = [];
        var dmNextPortWharfCode = [];
        var dmPortRegionCode = [];
        var dmPortHarbourCode = [];
        var dmPortWharfCode = [];
        var dmShipTypeCode = [];
        var dmFlagStateOfShip = [];
        var dmNoticeShipType = [];
        var dmChanelCodeList = [];
        var dmShipAgencyCode = [];
        var dmCargoCategory = [];
        var dmCargo = [];
        var dmShipOperator = [];
        var dmShipOwner = [];
        var actions = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i].hasOwnProperty('shipOperatorCode') && data[i].shipOperatorCode && (!data[i].hasOwnProperty('shipOperatorName') || !data[i]['shipOperatorName'])) {
            dmShipOperator.push({
              code: data[i]['shipOperatorCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shipOwnerCode') && data[i].shipOwnerCode && (!data[i].hasOwnProperty('shipOwnerName') || !data[i]['shipOwnerName'])) {
            dmShipOwner.push({
              code: data[i]['shipOwnerCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shipAgencyCode') && data[i].shipAgencyCode && (!data[i].hasOwnProperty('shipAgencyName') || !data[i]['shipAgencyName'])) {
            dmShipAgencyCode.push({
              code: data[i]['shipAgencyCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('cargoCode') && data[i].cargoCode && (!data[i].hasOwnProperty('cargoName') || !data[i]['cargoName'])) {
            dmCargo.push({
              code: data[i]['cargoCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('cargoCategory') && data[i].cargoCategory && (!data[i].hasOwnProperty('cargoCategoryName') || !data[i]['cargoCategoryName'])) {
            dmCargoCategory.push({
              code: data[i]['cargoCategory'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('chanelCodeList') && data[i].chanelCodeList) {
            dmChanelCodeList.push({
              code: data[i]['chanelCodeList'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('flagStateOfShip') && data[i].flagStateOfShip) {
            dmFlagStateOfShip.push({
              code: data[i]['flagStateOfShip'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('noticeShipType') && data[i].noticeShipType) {
            dmNoticeShipType.push({
              code: data[i]['noticeShipType'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('anchoringPortHarbourCode') && data[i].anchoringPortHarbourCode) {
            dmAnchoringPortHarbourCode.push({
              code: data[i]['anchoringPortHarbourCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('anchoringPortWharfCode') && data[i].anchoringPortWharfCode) {
            dmAnchoringPortWharfCode.push({
              code: data[i]['anchoringPortWharfCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shiftingPortHarbourCode') && data[i].shiftingPortHarbourCode) {
            dmShiftingPortHarbourCode.push({
              code: data[i]['shiftingPortHarbourCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shiftingPortWharfCode') && data[i].shiftingPortWharfCode) {
            dmShiftingPortWharfCode.push({
              code: data[i]['shiftingPortWharfCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shiftingPortRegionCode') && data[i].shiftingPortRegionCode) {
            dmShiftingPortRegionCode.push({
              code: data[i]['shiftingPortRegionCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('lastPortHarbourCode') && data[i].lastPortHarbourCode) {
            dmLastPortHarbourCode.push({
              code: data[i]['lastPortHarbourCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('lastPortWharfCode') && data[i].lastPortWharfCode) {
            dmLastPortWharfCode.push({
              code: data[i]['lastPortWharfCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('lastPortRegionCode') && data[i].lastPortRegionCode) {
            dmLastPortRegionCode.push({
              code: data[i]['lastPortRegionCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('nextMaritimePortCode') && data[i].nextMaritimePortCode) {
            dmNextMaritimePortCode.push({
              code: data[i]['nextMaritimePortCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('nextPortRegionCode') && data[i].nextPortRegionCode) {
            dmNextPortRegionCode.push({
              code: data[i]['nextPortRegionCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('nextPortHarbourCode') && data[i].nextPortHarbourCode) {
            dmNextPortHarbourCode.push({
              code: data[i]['nextPortHarbourCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('nextPortWharfCode') && data[i].nextPortWharfCode) {
            dmNextPortWharfCode.push({
              code: data[i]['nextPortWharfCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('portRegionCode') && data[i].portRegionCode) {
            dmPortRegionCode.push({
              code: data[i]['portRegionCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('portHarbourCode') && data[i].portHarbourCode) {
            dmPortHarbourCode.push({
              code: data[i]['portHarbourCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('portWharfCode') && data[i].portWharfCode) {
            dmPortWharfCode.push({
              code: data[i]['portWharfCode'],
              index: i
            });
          }
          if (data[i].hasOwnProperty('shipTypeCode') && data[i].shipTypeCode) {
            dmShipTypeCode.push({
              code: data[i]['shipTypeCode'],
              index: i
            });
          }
        }
        if (dmAnchoringPortHarbourCode.length) {
          var codeArr = dmAnchoringPortHarbourCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarbour, index) {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['anchoringPortHarbourCode']) {
                    data[index]['anchoringPortHarbourName'] = itemRes['portHarbourNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmAnchoringPortWharfCode.length) {
          var _codeArr = dmAnchoringPortWharfCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: _codeArr
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortWharf, index) {
                  if (itemRes['portWharfCode'] === itemPortWharf['anchoringPortWharfCode']) {
                    data[index]['anchoringPortWharfName'] = itemRes['portWharfNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmShiftingPortHarbourCode.length) {
          var _codeArr2 = dmShiftingPortHarbourCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: _codeArr2
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarbour, index) {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['shiftingPortHarbourCode']) {
                    data[index]['shiftingPortHarbourName'] = itemRes['portHarbourNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmShiftingPortWharfCode.length) {
          var _codeArr3 = dmShiftingPortWharfCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: _codeArr3
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortWharf, index) {
                  if (itemRes['portWharfCode'] === itemPortWharf['shiftingPortWharfCode']) {
                    data[index]['shiftingPortWharfName'] = itemRes['portWharfNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmShiftingPortRegionCode.length) {
          var _codeArr4 = dmShiftingPortRegionCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_REGION',
            portRegionCode: _codeArr4
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortRegion, index) {
                  if (itemRes['portRegionCode'] === itemPortRegion['shiftingPortRegionCode']) {
                    data[index]['shiftingPortRegionName'] = itemRes['portRegionNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmLastPortHarbourCode.length) {
          var _codeArr5 = dmLastPortHarbourCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: _codeArr5
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarbour, index) {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['lastPortHarbourCode']) {
                    data[index]['lastPortHarbourName'] = itemRes['portHarbourNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmLastPortWharfCode.length) {
          var _codeArr6 = dmLastPortWharfCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: _codeArr6
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortWharf, index) {
                  if (itemRes['portWharfCode'] === itemPortWharf['lastPortWharfCode']) {
                    data[index]['lastPortWharfName'] = itemRes['portWharfNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmLastPortRegionCode.length) {
          var _codeArr7 = dmLastPortRegionCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_REGION',
            portRegionCode: _codeArr7
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortRegion, index) {
                  if (itemRes['portRegionCode'] === itemPortRegion['lastPortRegionCode']) {
                    data[index]['lastPortRegionName'] = itemRes['portRegionNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmNextMaritimePortCode.length) {
          var _codeArr8 = dmNextMaritimePortCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_MARITIME',
            maritimeCode: _codeArr8
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemMaritime, index) {
                  if (itemRes['maritimeCode'] === itemMaritime['nextMaritimePortCode']) {
                    data[index]['nextMaritimePortName'] = itemRes['maritimeNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmNextPortRegionCode.length) {
          var _codeArr9 = dmNextPortRegionCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portRegionCode: _codeArr9
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortRegion, index) {
                  if (itemRes['portRegionCode'] === itemPortRegion['nextPortRegionCode']) {
                    data[index]['nextPortRegionName'] = itemRes['portRegionNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmNextPortHarbourCode.length) {
          var _codeArr10 = dmNextPortHarbourCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: _codeArr10
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarbour, index) {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['nextPortHarbourCode']) {
                    data[index]['nextPortHarbourName'] = itemRes['portHarbourNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmNextPortWharfCode.length) {
          var _codeArr11 = dmNextPortWharfCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portWharfCode: _codeArr11
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortWharf, index) {
                  if (itemRes['portWharfCode'] === itemPortWharf['nextPortWharfCode']) {
                    data[index]['nextPortWharfName'] = itemRes['portWharfNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmPortRegionCode.length) {
          var _codeArr12 = dmPortRegionCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portRegionCode: _codeArr12
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortRegion, index) {
                  if (itemRes['portRegionCode'] === itemPortRegion['portRegionCode']) {
                    data[index]['portRegionName'] = itemRes['portRegionNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmPortHarbourCode.length) {
          var _codeArr13 = dmPortHarbourCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: _codeArr13
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarbour, index) {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['portHarbourCode']) {
                    data[index]['portHarbourName'] = itemRes['portHarbourNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmPortWharfCode.length) {
          var _codeArr14 = dmPortWharfCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portWharfCode: _codeArr14
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemPortHarWharf, index) {
                  if (itemRes['portWharfCode'] === itemPortHarWharf['portWharfCode']) {
                    data[index]['portWharfName'] = itemRes['portWharfNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmShipTypeCode.length) {
          var _codeArr15 = dmShipTypeCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            shipTypeCode: _codeArr15
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemShipType, index) {
                  if (itemRes['shipTypeCode'] === itemShipType['shipTypeCode']) {
                    data[index]['shipTypeName'] = itemRes['shipTypeNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmFlagStateOfShip.length) {
          var _codeArr16 = dmFlagStateOfShip.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_STATE',
            stateCode: _codeArr16
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemShipType, index) {
                  if (itemRes['stateCode'] === itemShipType['flagStateOfShip']) {
                    data[index]['flagStateOfShipName'] = itemRes['stateName'];
                  }
                });
              });
            }
          }));
        }
        if (dmShipAgencyCode.length) {
          var _codeArr17 = dmShipAgencyCode.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_SHIP_AGENCY',
            shipAgencyCode: _codeArr17
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemShipAgency, index) {
                  if (itemRes['shipAgencyCode'] === itemShipAgency['shipAgencyCode']) {
                    data[index]['shipAgencyName'] = itemRes['shipAgencyNameVN'];
                  }
                });
              });
            }
          }));
        }
        if (dmChanelCodeList.length) {
          var _codeArr18 = dmChanelCodeList.map(function (item) {
            data[item['index']]['chanelCodeListName'] = [];
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_TUYEN_LUONG',
            code: _codeArr18
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemChanelCodeList, index) {
                  if (itemChanelCodeList['chanelCodeList']) {
                    var chanelCodeListTmp = itemChanelCodeList['chanelCodeList'].split(',');
                    for (var i = 0; i < chanelCodeListTmp.length; i++) {
                      if (itemRes['code'] === chanelCodeListTmp[i]) {
                        data[index]['chanelCodeListName'].push(itemRes['name']);
                      }
                    }
                  }
                });
              });
            }
          }));
        }
        if (dmNoticeShipType.length) {
          vm.itemsSup['noticeShipTypeItems'].forEach(function (itemRes) {
            data.forEach(function (itemNoticeShipType, index) {
              if (itemRes['itemValue'] === itemNoticeShipType['noticeShipType'].toString()) {
                data[index]['noticeShipTypeName'] = itemRes['itemText'];
              }
            });
          });
        }
        if (dmCargoCategory.length) {
          var _codeArr19 = dmCargoCategory.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItem_2Name({
            dataGroupId: '119',
            code: _codeArr19
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemCargoCategory, index) {
                  if (itemRes['code'] === itemCargoCategory['cargoCategory']) {
                    data[index]['cargoCategoryName'] = itemRes['name'];
                  }
                });
              });
            }
          }));
        }
        if (dmCargo.length) {
          var _codeArr20 = dmCargo.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_DATAITEM_GROUP124',
            code: _codeArr20
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemCargo, index) {
                  if (itemRes['code0'] === itemCargo['cargoCode']) {
                    data[index]['cargoName'] = itemRes['name'];
                  }
                });
              });
            }
          }));
        }
        if (dmShipOperator.length) {
          var _codeArr21 = dmShipOperator.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_VMA_SHIP_OWNER',
            isShipOperator: 1,
            code: _codeArr21
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemShipOperator, index) {
                  if (itemRes['shipOwnerCode'] === itemShipOperator['shipOperatorCode']) {
                    data[index]['shipOperatorName'] = itemRes['companyName'];
                  }
                });
              });
            }
          }));
        }
        if (dmShipOwner.length) {
          var _codeArr22 = dmShipOwner.map(function (item) {
            return item.code;
          }).join(',');
          actions.push(vm.getDmItemName({
            categoryId: 'DM_VMA_SHIP_OWNER',
            isShipOwner: 1,
            code: _codeArr22
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(function (itemRes) {
                data.forEach(function (itemShipOwner, index) {
                  if (itemRes['shipOwnerCode'] === itemShipOwner['shipOwnerCode']) {
                    data[index]['shipOwnerName'] = itemRes['companyName'];
                  }
                });
              });
            }
          }));
        }
        vm.loadingTableAlll = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(actions).then(function (results) {
          vm.loadingTableAlll = false;
          for (var i = 0; i < data.length; i++) {
            if (data[i].hasOwnProperty('chanelCodeList') && data[i].chanelCodeList) {
              if (typeof data[i].chanelCodeList === 'string') {
                data[i]['chanelCodeList'] = data[i]['chanelCodeList'].split(',');
              }
            } else if (data[i].hasOwnProperty('chanelCodeList') && !data[i].chanelCodeList) {
              data[i]['chanelCodeList'] = [];
            }
          }
          console.log('data+++++++++', data);
          resolve(data);
        }).catch(function (xhr) {
          console.log('data______table____error=======>>>>>>>', xhr);
          reject(xhr);
        });
      });
    },

    getDmItem_2Name: function getDmItem_2Name(data) {
      var vm = this;
      if (!data) {
        console.log('valid data param!!!!!!!');
        return;
      }
      var param = {};
      if (data) {
        for (var key in data) {
          param[key] = data[key];
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('loadDataItems', param).then(function (result) {
          resolve(result);
        }).catch(function (xhr) {
          console.log(xhr);
          reject(xhr);
        });
      });
    },
    getDmItemName: function getDmItemName(data) {
      var vm = this;
      if (!data) {
        console.log('valid data param!!!!!!!');
        return;
      }
      var param = {};
      if (data) {
        for (var key in data) {
          param[key] = data[key];
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('loadDataDm', param).then(function (result) {
          resolve(result);
        }).catch(function (xhr) {
          console.log(xhr);
          reject(xhr);
        });
      });
    },
    parseDate: function parseDate(date) {
      if (!date) return null;
      console.log(date);

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
    },
    loadDataTauDenCang: function loadDataTauDenCang() {
      var vm = this;
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        var url = resultInit['getVmaItinerarySchedule_Come_URL'];
        vm.loadingTableTauDen = true;
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          noticeShipType: 1,
          maritimeCode: vm.maritimeCode,
          markedAsArrival: '3,4,5,7,8,9',
          shipBoat: 'SHIP',
          timeOfArrival: vm.searchTopTauAll
        }).then(function (result) {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauDen = false;
            vm.itemsDsTauDenCang = result['data'];
          } else {
            vm.itemsDsTauDenCang = [];
            vm.loadingTableTauDen = false;
          }
        }).catch(function (xhr) {
          vm.loadingTableTauDen = false;
        });
      });
    },
    loadDataTauRoiCang: function loadDataTauRoiCang() {
      var vm = this;
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        var url = resultInit['getVmaItinerarySchedule_Leave_URL'];
        vm.loadingTableTauRoi = true;
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          noticeShipType: 2,
          shipBoat: 'SHIP',
          maritimeCode: vm.maritimeCode,
          markedAsDeparture: '3,4,5,7,8,9',
          timeOfDeparture: vm.searchTopTauAll
        }).then(function (result) {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauRoi = false;
            vm.itemsDsTauRoiCang = result['data'];
          } else {
            vm.itemsDsTauRoiCang = [];
            vm.loadingTableTauRoi = false;
          }
        });
      });
    },
    loadDataTauDiChuyen: function loadDataTauDiChuyen() {
      var vm = this;
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        var url = resultInit['getVmaScheduleShiftingURL'];
        vm.loadingTableTauDiChuyen = true;
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          maritimeCode: vm.maritimeCode,
          requestState: 4,
          noticeShipType: 4,
          shiftingDate: vm.searchTopTauAll
        }).then(function (result) {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauDiChuyen = false;
            vm.itemsDsTauDiChuyen = result['data'] || [];
          } else {
            vm.itemsDsTauDiChuyen = [];
            vm.loadingTableTauDiChuyen = false;
          }
        });
      });
    }
  }
});

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_support_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrolling_table__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scrolling_table__);







var groupBy = function groupBy(key) {
  return function (array) {
    return array.reduce(function (objectsByKeyValue, obj) {
      var value = obj[key];
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});
  };
};
__WEBPACK_IMPORTED_MODULE_3_toastr___default.a.options = {
  'closeButton': true,
  'timeOut': '3000'
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {
    'vue-scrolling-table': __WEBPACK_IMPORTED_MODULE_4_vue_scrolling_table___default.a
  },
  provide: {},
  data: function data() {
    return {
      dialogPTTND: false,
      arrNotData: [],
      supportData: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a,
      searchTopTauAll: '',
      dataItems: {},
      menuTopTauAll: false,
      dateSearchTopTauAll: '',
      headersKhDieuDong: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a.headersTauKhDieuDong,
      loadingDataItem: false,
      portRegionItems: [],
      adv: {},
      loadingDialog: false,
      typeNavigate: '',
      itemsDialog: [],
      headersDialog: [],
      headersDialogPTTND: [{
        'text': 'STT',
        'align': 'left',
        'sortable': false,
        'id': 'stt',
        'type': 'text',
        'style': {
          'min-width': '5em',
          'max-width': '5em'
        }
      }, {
        'text': 'Tên phương tiện',
        'align': 'center',
        'sortable': false,
        'value': 'tentau',
        'id': 'shipName',
        'display': 'shipName',
        'type': 'text',
        'style': {
          'min-width': '19em',
          'max-width': '19em'
        }
      }, {
        'text': 'Số đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'title',
        'id': 'registryNumber',
        'display': 'registryNumber',
        'type': 'text',
        'style': {
          'min-width': '14em',
          'max-width': '14em'
        }
      }, {
        'text': 'Ngày hết hạn <br> đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'ngayhethandk',
        'id': 'expiredDate',
        'display': 'expiredDate',
        'type': 'text',
        'style': {
          'min-width': '16em',
          'max-width': '16em'
        }
      }, {
        'text': 'Xem lịch sử vào rời',
        'align': 'center',
        'sortable': false,
        'value': 'xemlichsu',
        'id': 'xemLichSu',
        'display': 'xemLichSu',
        'type': 'text',
        'style': {
          'min-width': '15.1em',
          'max-width': '15.1em'
        }
      }],
      headersDialogTau: [{
        'text': 'STT',
        'align': 'left',
        'sortable': false,
        'id': 'stt',
        'type': 'text',
        'style': {
          'min-width': '5em',
          'max-width': '5em'
        }
      }, {
        'text': 'Tên tàu',
        'align': 'center',
        'sortable': false,
        'value': 'tentau',
        'id': 'shipName',
        'display': 'shipName',
        'type': 'text',
        'style': {
          'min-width': '15em',
          'max-width': '15em'
        }
      }, {
        'text': 'Số đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'title',
        'id': 'registryNumber',
        'display': 'registryNumber',
        'type': 'text',
        'style': {
          'min-width': '11em',
          'max-width': '11em'
        }
      }, {
        'text': 'Hô hiệu',
        'align': 'center',
        'sortable': false,
        'value': 'hohieu',
        'id': 'callSign',
        'display': 'callSign',
        'type': 'text',
        'style': {
          'min-width': '11em',
          'max-width': '11em'
        }
      }, {
        'text': 'Ngày hết hạn <br> đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'ngayhethandk',
        'id': 'expiredDate',
        'display': 'expiredDate',
        'type': 'text',
        'style': {
          'min-width': '12em',
          'max-width': '12em'
        }
      }, {
        'text': 'Xem lịch sử vào rời',
        'align': 'center',
        'sortable': false,
        'value': 'xemlichsu',
        'id': 'xemLichSu',
        'display': 'xemLichSu',
        'type': 'text',
        'style': {
          'min-width': '15.1em',
          'max-width': '15.1em'
        }
      }],
      totalDsTau: 0,
      initData: null,
      titleDS: '',
      maritimeCode: 0
    };
  },
  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true);
      } else {
        vm.$store.commit('setSwitch1', false);
      }
    },
    dateSearchTopTauAll: function dateSearchTopTauAll(val) {
      this.searchTopTauAll = this.parseDate(val);
      this.loadDataTau();
    }
  },
  computed: {
    switch1: function switch1() {
      return this.$store.getters.switch1;
    },
    checkShowBtn: function checkShowBtn() {
      var vm = this;
      if (vm.initData) {
        if (vm.initData.hasOwnProperty('user') && vm.initData.user && vm.initData.user['userId']) {
          return true;
        }
      }
      return false;
    }
  },
  created: function created() {
    var vm = this;

    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.initData = result;
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true);
      } else {
        vm.$store.commit('setSwitch1', false);
      }
      vm.loadMaritimeCode().then(function (result) {
        vm.getCurentDate();
      });
    });
  },

  methods: {
    checkInitfrom: function checkInitfrom(item) {
      if (item && item['shortInitFrom']) {
        return item['shortInitFrom'];
      } else if (item && item['initFrom']) {
        return item['initFrom'];
      }
      return 'P/S';
    },

    loadMaritimeCode: function loadMaritimeCode(query) {
      var vm = this;
      var param = {};
      param['isDelete'] = 0;
      param['start'] = -1;
      param['end'] = -1;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0;
            resolve(result[0]);
          } else {
            resolve({});
          }
        }).catch(function (xhr) {
          console.log(xhr);
          reject(false);
        });
      });
    },
    loadDsTau: function loadDsTau(data) {
      var vm = this;
      vm.loadingDialog = true;
      vm.$store.dispatch('loadInitResource').then(function (result) {
        var query = {};
        query['url'] = result['getVmaShip_Boat_URL'];
        query['getShip'] = true;
        query['start'] = 0;
        query['end'] = 15;
        for (var key in data) {
          query[key] = data[key];
        }
        for (var keyAdv in vm.adv) {
          query[keyAdv] = vm.adv[keyAdv];
        }
        vm.$store.dispatch('loadDanhSachTauBien', query).then(function (result) {
          if (result && result['data']) {
            vm.itemsDialog = result['data'];
          } else {
            vm.itemsDialog = [];
          }
          vm.totalDsTau = result['total'] || 0;
          vm.loadingDialog = false;
        }).catch(function (xhr) {
          vm.itemsDialog = [];
          vm.loadingDialog = false;
        });
      });
    },
    inKeHoachDieuDong: function inKeHoachDieuDong() {
      var vm = this;
      vm.$store.dispatch('inKeHoachDieuDongTheoNgay', {
        start: -1,
        end: -1,
        maritimeCode: vm.maritimeCode,
        markedAsArrival: '3,4,5,7,8,9',
        markedAsDeparture: '3,4,5,7,8,9',
        noticeShipType: '1,2,4',
        timeOfArrival: vm.searchTopTauAll
      }).then(function (result) {
        if (result) {
          window.open(result, '_blank');
        } else {
          __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Không tìm thấy file!');
        }
      }).catch(function (xhr) {
        __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error('Không tìm thấy file!');
      });
    },

    loadPortRegion: function loadPortRegion(query, data) {
      var vm = this;
      var param = {
        categoryId: 'DM_PORT_REGION'
      };
      if (vm.id && vm.id !== '0') {
        delete param['isDelete'];
      } else {
        param['isDelete'] = 0;
      }
      if (query) {
        for (var key in query) {
          param[key] = query[key];
        }
      }
      param['maritimeCode'] = vm.maritimeCode;
      param['start'] = -1;
      param['end'] = -1;
      vm.$store.dispatch('loadDataDm', param).then(function (result) {
        vm.portRegionItems = result;
        var arrNotData = [];
        if (data) {
          vm.portRegionItems.forEach(function (item, index) {
            if (!data.hasOwnProperty(item['portRegionCode'])) {
              console.log('not Property', item['portRegionCode']);
              arrNotData.push(item['portRegionNameVN']);
            }
          });
        }
        vm.arrNotData = arrNotData;
      }).catch(function (xhr) {
        console.log(xhr);
      });
    },
    changeTypePart: function changeTypePart() {
      var vm = this;
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        });
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        });
      }
    },
    getCurentDate: function getCurentDate() {
      var date = new Date();
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    parseDate: function parseDate(date) {
      if (!date) return null;
      console.log(date);

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
    },
    loadDataTau: function loadDataTau() {
      var vm = this;

      vm.loadingDataItem = true;
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var url = resultInit['findVmaItinerary_VmaItinerarySchedule_VmaScheduleShifting_URL'];
          vm.$store.dispatch('loadDanhSachTauBien', {
            url: url,
            start: -1,
            end: -1,
            maritimeCode: vm.maritimeCode,
            markedAsArrival: '3,4,5,7,8,9',
            markedAsDeparture: '3,4,5,7,8,9',
            noticeShipType: '1,2,4',
            timeOfArrival: vm.searchTopTauAll
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              console.log('Source=====dataItem==============>>>>>>>>', result);
              var data = result['data'] || __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a['data'];
              var groupByPortRegionName = groupBy('portRegionCode');
              vm.dataItems = groupByPortRegionName(data);
              console.log('data+++dataItems===================>>>>>>>>', vm.dataItems);
              vm.loadingDataItem = false;
              vm.loadPortRegion(null, vm.dataItems);
              resolve(vm.dataItems);
            } else {
              vm.loadingDataItem = false;
              resolve([]);
            }
          }).catch(function (xhr) {
            vm.loadingDataItem = false;
            resolve([]);
          });
        });
      });
    }
  }
});

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_support_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_support_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrolling_table__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrolling_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_toastr__);







__WEBPACK_IMPORTED_MODULE_4_toastr___default.a.options = {
  'closeButton': true,
  'timeOut': '3000'
};
var groupBy = function groupBy(key) {
  return function (array) {
    return array.reduce(function (objectsByKeyValue, obj) {
      var value = obj[key];
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});
  };
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {
    'vue-scrolling-table': __WEBPACK_IMPORTED_MODULE_3_vue_scrolling_table___default.a
  },
  provide: {},
  data: function data() {
    return {
      nameOfShip: '',
      dialogTauXC: false,
      typeNavigate: '',
      loadingDialog: false,
      dialogPTTND: false,
      titleDS: '',
      adv: {},
      selectAll: false,
      selectItems: [],
      itemsDialog: [],
      itemsDialogXC: [],
      arrNotData: [],
      supportData: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a,
      searchTopTauAll: '',
      dataItems: {},
      menuTopTauAll: false,
      dateSearchTopTauAll: '',
      headersKhDieuDong: __WEBPACK_IMPORTED_MODULE_2__store_support_json___default.a.headersTauTrongCang,
      loadingDataItem: false,
      portRegionItems: [],
      itineraryNo: '',
      maritimeCode: 0
    };
  },
  watch: {
    '$route': function $route(newRoute, oldRoute) {
      var vm = this;
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true);
      } else {
        vm.$store.commit('setSwitch1', false);
      }
    },
    dateSearchTopTauAll: function dateSearchTopTauAll(val) {
      this.searchTopTauAll = this.parseDate(val);
      this.loadDataTau();
    },
    selectItems: function selectItems(val) {
      var vm = this;
      if (val.length) {
        vm.selectAll = true;
      } else {
        vm.selectAll = false;
      }
    }
  },
  computed: {
    loadingInitData: function loadingInitData() {
      return this.$store.getters.loadingInitData;
    },
    switch1: function switch1() {
      return this.$store.getters.switch1;
    }
  },
  created: function created() {
    var vm = this;
    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(function (result) {
        if (vm.code === 'KeHoachDieuDongTau2') {
          vm.$store.commit('setSwitch1', true);
        } else {
          vm.$store.commit('setSwitch1', false);
        }

        vm.getCurentDate();
        vm.addColumnTable();
        vm.$store.commit('setPttnd', false);
      });
    });
  },

  methods: {
    loadMaritimeCode: function loadMaritimeCode(query) {
      var vm = this;
      var param = {};
      param['isDelete'] = 0;
      param['start'] = -1;
      param['end'] = -1;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0;
            resolve(result[0]);
          } else {
            resolve({});
          }
        }).catch(function (xhr) {
          console.log(xhr);
          reject(false);
        });
      });
    },
    loadPortRegion: function loadPortRegion(query, data) {
      var vm = this;
      var param = {
        categoryId: 'DM_PORT_REGION'
      };
      if (vm.id && vm.id !== '0') {
        delete param['isDelete'];
      } else {
        param['isDelete'] = 0;
      }
      if (query) {
        for (var key in query) {
          param[key] = query[key];
        }
      }
      param['maritimeCode'] = vm.maritimeCode;
      param['start'] = -1;
      param['end'] = -1;
      vm.$store.dispatch('loadDataDm', param).then(function (result) {
        vm.portRegionItems = result;
        var arrNotData = [];
        if (data) {
          vm.portRegionItems.forEach(function (item, index) {
            if (!data.hasOwnProperty(item['portRegionCode'])) {
              console.log('not Property', item['portRegionCode']);
              arrNotData.push(item['portRegionNameVN']);
            }
          });
        }
        vm.arrNotData = arrNotData;
      }).catch(function (xhr) {
        console.log(xhr);
      });
    },
    changeTypePart: function changeTypePart() {
      var vm = this;
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        });
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        });
      }
    },
    getCurentDate: function getCurentDate() {
      var date = new Date();
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    parseDate: function parseDate(date) {
      if (!date) return null;
      console.log(date);

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
    },
    loadDataTau: function loadDataTau() {
      var vm = this;
      vm.loadingDataItem = true;
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var url = resultInit['getVmaScheduleAnchorage_Port_URL'];
          vm.$store.dispatch('loadDanhSachTauBien', {
            url: url,
            start: -1,
            end: -1,
            shipPosition: 2,
            flag: true,
            nameOfShip: vm.nameOfShip
          }).then(function (result) {
            if (result && !result.hasOwnProperty('errorCode')) {
              console.log('Source=====dataItem==============>>>>>>>>', result);
              var data = result['data'] || [];
              var groupByPortRegionName = groupBy('portRegionCode');
              vm.dataItems = groupByPortRegionName(data);
              console.log('data+++dataItems===================>>>>>>>>', vm.dataItems);
              vm.loadingDataItem = false;
              vm.loadPortRegion(null, vm.dataItems);
              resolve(vm.dataItems);
            } else {
              vm.loadingDataItem = false;
              resolve([]);
            }
          }).catch(function (xhr) {
            vm.loadingDataItem = false;
            resolve([]);
          });
        });
      });
    }
  }
});

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(631);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["a" /* GridPlugin */]);
var groupBy = function groupBy(key) {
  return function (array) {
    return array.reduce(function (objectsByKeyValue, obj) {
      var value = obj[key];
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {});
  };
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  provide: {
    grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* Group */]]
  },
  data: function data() {
    return {
      headers: [{
        label: 'Tên tàu',
        field: 'nameOfShip',
        width: '16%'
      }, {
        label: 'Quốc tịch',
        field: 'flagStateOfShipName',
        width: '10%'
      }, {
        label: 'Trọng tải',
        field: 'dwt'
      }, {
        label: 'Chiều dài',
        field: 'loa'
      }, {
        label: 'Dung tích',
        field: 'gt'
      }, {
        label: 'Cầu/ phao',
        field: 'portHarbourPortWharf',
        width: '17%'
      }, {
        label: 'Thời gian bắt đầu neo',
        field: 'anchoringDateFrom'
      }, {
        label: 'Thời gian kết thúc neo',
        field: 'anchoringDateTo'
      }],
      nameOfShip: '',
      itemsDsTauAll: [],
      groupOptions: { columns: ['portHarbourName'] },
      searchTopTauAll: '',
      menuTopTauAll: false,
      dateSearchTopTauAll: '',
      loadingTableAnchorage: false,
      maritimeCode: 0
    };
  },
  watch: {
    dateSearchTopTauAll: function dateSearchTopTauAll(val) {
      this.searchTopTauAll = this.parseDate(val);
      this.loadData();
    }
  },
  computed: {},
  created: function created() {
    var vm = this;

    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(function (result) {
        vm.getCurentDate();
      });
    });
  },
  mounted: function mounted() {
    this.$refs.myCustomTable.expandAll();
  },

  methods: {
    getCurentDate: function getCurentDate() {
      var date = new Date();
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },

    loadMaritimeCode: function loadMaritimeCode(query) {
      var vm = this;
      var param = {};
      param['isDelete'] = 0;
      param['start'] = -1;
      param['end'] = -1;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0;
            resolve(result[0]);
          } else {
            resolve({});
          }
        }).catch(function (xhr) {
          console.log(xhr);
          reject(false);
        });
      });
    },
    parseDate: function parseDate(date) {
      if (!date) return null;
      console.log(date.split('-'));

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
    },
    loadData: function loadData() {
      var vm = this;
      vm.loadingTableAnchorage = true;

      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        var url = resultInit['getVmaScheduleAnchorage_Port_URL'];
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          flag: true,
          start: -1,
          shipPosition: 2,
          maritimeCode: vm.maritimeCode,
          nameOfShip: vm.nameOfShip,
          end: -1
        }).then(function (result) {
          vm.loadingTableAnchorage = false;
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableAll = false;
            result['data'] = result['data'].map(function (item) {
              item['portHarbourPortWharf'] = item['portHarbourShortName'] + ', ' + item['portWharfShortName'];
              return item;
            }) || [];
            var groupByPortHarbourName = groupBy('portHarbourName');
            var dataTmp = groupByPortHarbourName(result['data']);
            var dataConvert = [];
            for (var key in dataTmp) {
              dataConvert.push({
                mode: 'span',
                label: key,
                html: false,
                children: dataTmp[key]
              });
            }
            vm.itemsDsTauAll = dataConvert;
            console.log('dataConvert++++++++++++++++', dataConvert);
          } else {
            vm.itemsDsTauAll = [];
          }
        }).catch(function (xhr) {
          vm.loadingTableAnchorage = false;
        });
      });
    }
  }
});

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 300,
	"./af.js": 300,
	"./ar": 307,
	"./ar-dz": 301,
	"./ar-dz.js": 301,
	"./ar-kw": 302,
	"./ar-kw.js": 302,
	"./ar-ly": 303,
	"./ar-ly.js": 303,
	"./ar-ma": 304,
	"./ar-ma.js": 304,
	"./ar-sa": 305,
	"./ar-sa.js": 305,
	"./ar-tn": 306,
	"./ar-tn.js": 306,
	"./ar.js": 307,
	"./az": 308,
	"./az.js": 308,
	"./be": 309,
	"./be.js": 309,
	"./bg": 310,
	"./bg.js": 310,
	"./bm": 311,
	"./bm.js": 311,
	"./bn": 312,
	"./bn.js": 312,
	"./bo": 313,
	"./bo.js": 313,
	"./br": 314,
	"./br.js": 314,
	"./bs": 315,
	"./bs.js": 315,
	"./ca": 316,
	"./ca.js": 316,
	"./cs": 317,
	"./cs.js": 317,
	"./cv": 318,
	"./cv.js": 318,
	"./cy": 319,
	"./cy.js": 319,
	"./da": 320,
	"./da.js": 320,
	"./de": 323,
	"./de-at": 321,
	"./de-at.js": 321,
	"./de-ch": 322,
	"./de-ch.js": 322,
	"./de.js": 323,
	"./dv": 324,
	"./dv.js": 324,
	"./el": 325,
	"./el.js": 325,
	"./en-au": 326,
	"./en-au.js": 326,
	"./en-ca": 327,
	"./en-ca.js": 327,
	"./en-gb": 328,
	"./en-gb.js": 328,
	"./en-ie": 329,
	"./en-ie.js": 329,
	"./en-il": 330,
	"./en-il.js": 330,
	"./en-nz": 331,
	"./en-nz.js": 331,
	"./eo": 332,
	"./eo.js": 332,
	"./es": 335,
	"./es-do": 333,
	"./es-do.js": 333,
	"./es-us": 334,
	"./es-us.js": 334,
	"./es.js": 335,
	"./et": 336,
	"./et.js": 336,
	"./eu": 337,
	"./eu.js": 337,
	"./fa": 338,
	"./fa.js": 338,
	"./fi": 339,
	"./fi.js": 339,
	"./fo": 340,
	"./fo.js": 340,
	"./fr": 343,
	"./fr-ca": 341,
	"./fr-ca.js": 341,
	"./fr-ch": 342,
	"./fr-ch.js": 342,
	"./fr.js": 343,
	"./fy": 344,
	"./fy.js": 344,
	"./gd": 345,
	"./gd.js": 345,
	"./gl": 346,
	"./gl.js": 346,
	"./gom-latn": 347,
	"./gom-latn.js": 347,
	"./gu": 348,
	"./gu.js": 348,
	"./he": 349,
	"./he.js": 349,
	"./hi": 350,
	"./hi.js": 350,
	"./hr": 351,
	"./hr.js": 351,
	"./hu": 352,
	"./hu.js": 352,
	"./hy-am": 353,
	"./hy-am.js": 353,
	"./id": 354,
	"./id.js": 354,
	"./is": 355,
	"./is.js": 355,
	"./it": 356,
	"./it.js": 356,
	"./ja": 357,
	"./ja.js": 357,
	"./jv": 358,
	"./jv.js": 358,
	"./ka": 359,
	"./ka.js": 359,
	"./kk": 360,
	"./kk.js": 360,
	"./km": 361,
	"./km.js": 361,
	"./kn": 362,
	"./kn.js": 362,
	"./ko": 363,
	"./ko.js": 363,
	"./ky": 364,
	"./ky.js": 364,
	"./lb": 365,
	"./lb.js": 365,
	"./lo": 366,
	"./lo.js": 366,
	"./lt": 367,
	"./lt.js": 367,
	"./lv": 368,
	"./lv.js": 368,
	"./me": 369,
	"./me.js": 369,
	"./mi": 370,
	"./mi.js": 370,
	"./mk": 371,
	"./mk.js": 371,
	"./ml": 372,
	"./ml.js": 372,
	"./mn": 373,
	"./mn.js": 373,
	"./mr": 374,
	"./mr.js": 374,
	"./ms": 376,
	"./ms-my": 375,
	"./ms-my.js": 375,
	"./ms.js": 376,
	"./mt": 377,
	"./mt.js": 377,
	"./my": 378,
	"./my.js": 378,
	"./nb": 379,
	"./nb.js": 379,
	"./ne": 380,
	"./ne.js": 380,
	"./nl": 382,
	"./nl-be": 381,
	"./nl-be.js": 381,
	"./nl.js": 382,
	"./nn": 383,
	"./nn.js": 383,
	"./pa-in": 384,
	"./pa-in.js": 384,
	"./pl": 385,
	"./pl.js": 385,
	"./pt": 387,
	"./pt-br": 386,
	"./pt-br.js": 386,
	"./pt.js": 387,
	"./ro": 388,
	"./ro.js": 388,
	"./ru": 389,
	"./ru.js": 389,
	"./sd": 390,
	"./sd.js": 390,
	"./se": 391,
	"./se.js": 391,
	"./si": 392,
	"./si.js": 392,
	"./sk": 393,
	"./sk.js": 393,
	"./sl": 394,
	"./sl.js": 394,
	"./sq": 395,
	"./sq.js": 395,
	"./sr": 397,
	"./sr-cyrl": 396,
	"./sr-cyrl.js": 396,
	"./sr.js": 397,
	"./ss": 398,
	"./ss.js": 398,
	"./sv": 399,
	"./sv.js": 399,
	"./sw": 400,
	"./sw.js": 400,
	"./ta": 401,
	"./ta.js": 401,
	"./te": 402,
	"./te.js": 402,
	"./tet": 403,
	"./tet.js": 403,
	"./tg": 404,
	"./tg.js": 404,
	"./th": 405,
	"./th.js": 405,
	"./tl-ph": 406,
	"./tl-ph.js": 406,
	"./tlh": 407,
	"./tlh.js": 407,
	"./tr": 408,
	"./tr.js": 408,
	"./tzl": 409,
	"./tzl.js": 409,
	"./tzm": 411,
	"./tzm-latn": 410,
	"./tzm-latn.js": 410,
	"./tzm.js": 411,
	"./ug-cn": 412,
	"./ug-cn.js": 412,
	"./uk": 413,
	"./uk.js": 413,
	"./ur": 414,
	"./ur.js": 414,
	"./uz": 416,
	"./uz-latn": 415,
	"./uz-latn.js": 415,
	"./uz.js": 416,
	"./vi": 417,
	"./vi.js": 417,
	"./x-pseudo": 418,
	"./x-pseudo.js": 418,
	"./yo": 419,
	"./yo.js": 419,
	"./zh-cn": 420,
	"./zh-cn.js": 420,
	"./zh-hk": 421,
	"./zh-hk.js": 421,
	"./zh-tw": 422,
	"./zh-tw.js": 422
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(722),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(47)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(721),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-1",
    staticStyle: {
      "width": "170px",
      "flex": "none"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Nhập tên tàu"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.loadDataTau()
      }
    },
    model: {
      value: (_vm.nameOfShip),
      callback: function($$v) {
        _vm.nameOfShip = $$v
      },
      expression: "nameOfShip"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 mr-2 py-0 my-0",
    staticStyle: {
      "text-transform": "none",
      "color": "#1d52e8"
    },
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.loadDataTau()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("search")]), _vm._v(" Tìm kiếm")], 1)], 1), _vm._v(" "), (_vm.loadingDataItem) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataItems), function(value, name) {
    return _c('div', [_c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n      " + _vm._s(value[0]['portRegionName'] || '') + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3",
      staticStyle: {
        "overflow": "auto"
      }
    }, [_c('v-data-table', {
      staticClass: "table-bordered danhSachHoSoTable__class",
      attrs: {
        "headers": _vm.headersKhDieuDong,
        "items": value,
        "hide-actions": "",
        "no-data-text": 'Không tìm thấy hồ sơ ',
        "no-results-text": 'Không tìm thấy hồ sơ '
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', {
            staticStyle: {
              "background": "#316BB6",
              "color": "#ffff"
            }
          }, [_c('th', [_c('v-checkbox', {
            on: {
              "change": function($event) {
                _vm.changeSelectAll(value)
              }
            },
            model: {
              value: (_vm.selectAll),
              callback: function($$v) {
                _vm.selectAll = $$v
              },
              expression: "selectAll"
            }
          })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
            return (header['id'] !== 'checkbox') ? _c('th', {
              staticStyle: {
                "color": "#ffff !important",
                "font-weight": "normal !important"
              },
              domProps: {
                "innerHTML": _vm._s(header.text)
              }
            }) : _vm._e()
          })], 2)]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('td', [_c('v-checkbox', {
            attrs: {
              "value": props.item
            },
            model: {
              value: (_vm.selectItems),
              callback: function($$v) {
                _vm.selectItems = $$v
              },
              expression: "selectItems"
            }
          })], 1), _vm._v(" "), _vm._l((_vm.headersKhDieuDong), function(itemKey, index) {
            return (itemKey['id'] !== 'checkbox') ? _c('td', {
              staticClass: "text-xs-center"
            }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
              return _c('div', {
                key: 'chanelCodeList' + index
              }, [_vm._v(_vm._s(item))])
            })) : (itemKey.id === 'portHarbourCode') ? _c('span', [_c('span', [_vm._v(_vm._s(props.item['portHarbourName']) + ", " + _vm._s(props.item['portWharfName']))])]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
          })]
        }
      }])
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.arrNotData), function(item) {
    return _c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Tàu thuyền trong cảng ")])])
}]}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Kế hoạch điều động tàu ngày " + _vm._s(_vm.searchTopTauAll))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "8px 8px 0px 10px"
    }
  }, [_vm._v("\n      Ngày: \n    ")]), _vm._v(" "), _c('v-menu', {
    ref: "menuTopTau",
    staticStyle: {
      "margin-top": "8px"
    },
    style: ({}),
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuTopTauAll),
      callback: function($$v) {
        _vm.menuTopTauAll = $$v
      },
      expression: "menuTopTauAll"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 my-0",
    attrs: {
      "slot": "activator",
      "persistent-hint": ""
    },
    slot: "activator",
    model: {
      value: (_vm.searchTopTauAll),
      callback: function($$v) {
        _vm.searchTopTauAll = $$v
      },
      expression: "searchTopTauAll"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": function($event) {
        _vm.menuTopTauAll = false
      }
    },
    model: {
      value: (_vm.dateSearchTopTauAll),
      callback: function($$v) {
        _vm.dateSearchTopTauAll = $$v
      },
      expression: "dateSearchTopTauAll"
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "size": "17"
    },
    on: {
      "click": function($event) {
        _vm.menuTopTauAll = !_vm.menuTopTauAll
      }
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('v-switch', {
    staticClass: "ml-4 mt-2",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.changeTypePart
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3"
  }, [_vm._v("\n    Kế hoạch tàu đến cảng\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.loadingTableTauDen) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauDenCang,
      "items": _vm.itemsDsTauDenCang,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6",
            "color": "#ffff"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauDenCang), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3 mb-3"
  }, [_vm._v("\n    Kế hoạch tàu rời cảng\n  ")]), _vm._v(" "), (_vm.loadingTableTauRoi) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauRoiCang,
      "items": _vm.itemsDsTauRoiCang,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6",
            "color": "#ffff"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauRoiCang), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3 mb-3"
  }, [_vm._v("\n    Kế hoạch tàu di chuyển\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.loadingTableTauDiChuyen) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauDiChuyen,
      "items": _vm.itemsDsTauDiChuyen,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauDiChuyen), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stateDisplay === 'KeHoachDieuDongTau') ? _c('jx-hanghai-ke-hoach-dieu-dong', {
    ref: "KeHoachDieuDongTau",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : (_vm.stateDisplay === 'KeHoachDieuDongTau2') ? _c('jx-hanghai-ke-hoach-dieu-dong-2', {
    ref: "KeHoachDieuDongTau2",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : (_vm.stateDisplay === 'TauTrongCang') ? _c('jx-hanghai-tau-trong-cang', {
    ref: "TauTrongCang",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : _c('jx-hanghai-vi-tri-tau-roi-cang', {
    ref: "ViTriTauTaiCang",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-1 pl-2",
    staticStyle: {
      "width": "170px",
      "flex": "none"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Nhập tên tàu"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.loadData()
      }
    },
    model: {
      value: (_vm.nameOfShip),
      callback: function($$v) {
        _vm.nameOfShip = $$v
      },
      expression: "nameOfShip"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 mr-2 py-0 my-0",
    staticStyle: {
      "text-transform": "none",
      "color": "#1d52e8"
    },
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.loadData()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("search")]), _vm._v(" Tìm kiếm")], 1)], 1), _vm._v(" "), (_vm.loadingTableAnchorage) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('vue-good-table', {
    ref: "myCustomTable",
    attrs: {
      "columns": _vm.headers,
      "rows": _vm.itemsDsTauAll,
      "groupOptions": {
        enabled: true,
        expand: true
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Vị trí tàu tại cảng")])])
}]}

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(!_vm.isKeToan) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Kế hoạch điều động tàu ngày " + _vm._s(_vm.searchTopTauAll))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "8px 8px 0px 10px"
    }
  }, [_vm._v("\n      Ngày: \n    ")]), _vm._v(" "), _c('v-menu', {
    ref: "menuTopTau",
    staticStyle: {
      "margin-top": "8px"
    },
    style: ({}),
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuTopTauAll),
      callback: function($$v) {
        _vm.menuTopTauAll = $$v
      },
      expression: "menuTopTauAll"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 my-0",
    attrs: {
      "slot": "activator",
      "persistent-hint": ""
    },
    slot: "activator",
    model: {
      value: (_vm.searchTopTauAll),
      callback: function($$v) {
        _vm.searchTopTauAll = $$v
      },
      expression: "searchTopTauAll"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": function($event) {
        _vm.menuTopTauAll = false
      }
    },
    model: {
      value: (_vm.dateSearchTopTauAll),
      callback: function($$v) {
        _vm.dateSearchTopTauAll = $$v
      },
      expression: "dateSearchTopTauAll"
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "size": "17"
    },
    on: {
      "click": function($event) {
        _vm.menuTopTauAll = !_vm.menuTopTauAll
      }
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('v-switch', {
    staticClass: "ml-4 mt-2",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.changeTypePart
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1), _vm._v(" "), (_vm.loadingDataItem) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataItems), function(value, name) {
    return _c('div', [_c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n      " + _vm._s(value[0]['portRegionName']) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3",
      staticStyle: {
        "overflow": "auto"
      }
    }, [_c('v-data-table', {
      staticClass: "table-bordered danhSachHoSoTable__class",
      attrs: {
        "headers": _vm.headersKhDieuDong,
        "items": value,
        "hide-actions": "",
        "no-data-text": 'Không tìm thấy hồ sơ ',
        "no-results-text": 'Không tìm thấy hồ sơ '
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', {
            staticStyle: {
              "background": "#316BB6",
              "color": "#ffff"
            }
          }, _vm._l((props.headers), function(header) {
            return _c('th', {
              staticStyle: {
                "color": "#ffff !important",
                "font-weight": "normal !important"
              },
              domProps: {
                "innerHTML": _vm._s(header.text)
              }
            })
          }))]
        }
      }, {
        key: "items",
        fn: function(props) {
          return _vm._l((_vm.headersKhDieuDong), function(itemKey, index) {
            return _c('td', {
              staticClass: "text-xs-center",
              style: (_vm.headersKhDieuDong[index]['style'])
            }, [(itemKey.id === 'chanelCodeList') ? _c('div', _vm._l((props.item[itemKey.display]), function(item, index) {
              return _c('div', {
                key: 'chanelCodeList' + index
              }, [_vm._v(_vm._s(item))])
            })) : (itemKey.id === 'timeOfArrival') ? _c('div', [(props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') ? _c('div', [_vm._v("\n                " + _vm._s(props.item['timeHHMMOfArrival']) + "\n              ")]) : _c('div', [_vm._v("\n                " + _vm._s(props.item['timeHHMMOfDeparture']) + "\n              ")])]) : (itemKey.id === 'tugboatList') ? _c('span', [(props.item['shortTugboatList'] && props.item['shortTugboatList'] !== 'null') ? _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['shortTugboatList'])
              }
            }) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['tugboatList'])
              }
            })]) : (itemKey.id === 'pilotList') ? _c('span', [(props.item['shortPilotList'] && props.item['shortPilotList'] !== 'null') ? _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['shortPilotList'])
              }
            }) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              },
              domProps: {
                "innerHTML": _vm._s(props.item['pilotList'])
              }
            })]) : ((props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : ((props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['initFrom'] || 'P/S'))])]) : ((props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['initFrom'] || 'P/S'))])]) : ((props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : (itemKey.id === 'portHarbourCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(_vm.checkInitfrom(props.item)))])]) : (itemKey.id === 'portWharfCode') ? _c('div', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['portHarbourShortName']) + ", " + _vm._s(props.item['portWharfShortName']))])]) : (itemKey.id === 'maxDraft') ? _c('span', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['maxDraft'] ? props.item['maxDraft'].replace('/', ' / ') : ''))])]) : (itemKey.id === 'shipAgencyCode') ? _c('span', [_c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item['shipAgencyShortName'] ? props.item['shipAgencyShortName'] : props.item['shipAgencyName']))])]) : _c('div', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(props.item[itemKey.display]))])])
          })
        }
      }])
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.arrNotData), function(item) {
    return _c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports = {"headers":[{"text":"STT","align":"left","sortable":false},{"text":"Tình trạng","align":"center","sortable":false,"value":"requestState"},{"text":"Mã bản khai","align":"center","sortable":false,"value":"title"},{"text":"Tên tàu","align":"center","sortable":false,"value":"tentau"},{"text":"Hô hiệu","align":"center","sortable":false,"value":"tentau"},{"text":"IMO","align":"center","sortable":false,"value":"tentau"},{"text":"Quốc tịch","align":"center","sortable":false,"value":"stateCode"},{"text":"Dự kiến tàu đến / rời","align":"center","sortable":false,"value":"tentau"},{"text":"Đại lý","align":"center","sortable":false,"value":"tentau"},{"text":"Thời gian nộp hồ sơ","align":"center","sortable":false,"value":"tentau"}],"headers_boss":[{"text":"STT","align":"left","sortable":false},{"text":"Tình trạng","align":"center","sortable":false,"value":"requestState"},{"text":"Mã bản khai","align":"center","sortable":false,"value":"title"},{"text":"Tên tàu","align":"center","sortable":false,"value":"tentau"},{"text":"Hô hiệu","align":"center","sortable":false,"value":"tentau"},{"text":"IMO","align":"center","sortable":false,"value":"tentau"},{"text":"Quốc tịch","align":"center","sortable":false,"value":"stateCode"},{"text":"Dự kiến tàu đến","align":"center","sortable":false,"value":"tentau"},{"text":"Đại lý","align":"center","sortable":false,"value":"tentau"},{"text":"Dự kiến tàu rời","align":"center","sortable":false,"value":"tentau"},{"text":"Thời gian nộp hồ sơ","align":"center","sortable":false,"value":"tentau"}],"headersPayment":[{"text":"","align":"left","sortable":false},{"text":"STT","align":"left","sortable":false},{"text":"Mã bản khai","align":"center","sortable":false,"value":"title"},{"text":"Tên tàu","align":"center","sortable":false,"value":"tentau"},{"text":"Quốc tịch","align":"center","sortable":false,"value":"stateCode"},{"text":"Đại lý","align":"center","sortable":false,"value":"tentau"},{"text":"Số phiếu tính tiền","align":"center","sortable":false,"value":"tentau"},{"text":"Ngày lập phiếu","align":"center","sortable":false,"value":"tentau"},{"text":"Tổng tiền","align":"center","sortable":false,"value":"tentau"},{"text":"Hành động","align":"center","sortable":false,"value":"tentau"},{"text":"Tính phí","align":"center","sortable":false,"value":"tinhphi"}],"headersPaymentView":[{"text":"STT","align":"left","sortable":false},{"text":"Mã bản khai","align":"center","sortable":false,"value":"title"},{"text":"Tên tàu","align":"center","sortable":false,"value":"tentau"},{"text":"Hô hiệu","align":"center","sortable":false,"value":"tentau"},{"text":"IMO","align":"center","sortable":false,"value":"tentau"},{"text":"Quốc tịch","align":"center","sortable":false,"value":"stateCode"},{"text":"Đại lý","align":"center","sortable":false,"value":"tentau"},{"text":"Số phiếu tính tiền","align":"center","sortable":false,"value":"tentau"},{"text":"Ngày lập phiếu","align":"center","sortable":false,"value":"tentau"},{"text":"Tổng tiền","align":"center","sortable":false,"value":"tentau"}],"langUI":{"ke_hoach":"kế hoạch","thu_tuc":"thủ tục","lanh_dao":"lãnh đạo","van_thu":"văn thư"},"langUITau":{"ke_hoach":"Kế hoạch tàu đến rời","thu_tuc":"Thủ tục"},"data_state":{"AD":"ANDORRA","AE":"UNITED ARAB EMIRATES","AF":"AFGANISTAN","AG":"ANTIGUA AND BARBUDA","AI":"ANGUILLA","AL":"ALBANIA","AM":"ARMENIA","AO":"ANGOLA","AR":"ARGENTINA","AS":"AMERICAN SAMOA","AT":"AUSTRIA","AU":"AUSTRALIA","AW":"ARUBA","AZ":"AZERBAIJAN","BA":"BOSNIA AND HERZEGOWINA","BB":"BARBADOS","BD":"BANGLADESH","BE":"BELGIUM","BF":"BURKINA FASO","BG":"BULGARIA","BH":"BAHRAIN","BI":"BURUNDI","BJ":"BENIN","BM":"BERMUDA","BN":"BRUNEI DARUSSALAM","BO":"BOLIVIA","BQ":"B.A.T.","BR":"BRAZIL","BS":"BAHAMAS","BT":"BHUTAN","BW":"BOTSWANA","BY":"BELARUS","BZ":"BELIZE","CA":"CANADA","CC":"COCOS (KEELING) ISLANDS","CD":"CONGO (DEMOCRATIC REP.)","CF":"CENTRAL AFRICAN REPUBLIC","CG":"CONGO","CH":"SWITZERLAND","CI":"COTE DIVOIRE (IVORY COAST)","CK":"COOK ISLANDS","CL":"CHILE","CM":"CAMEROON","CN":"CHINA","CO":"COLOMBIA","CR":"COSTA RICA","CU":"CUBA","CV":"CAPE VERDE ISLANDS","CX":"CHRISTMAS ISLANDS","CY":"CYPRUS","CZ":"CZECH REPUBLIC","DE":"GERMANY","DJ":"DJIBOUTI","DK":"DENMARK","DM":"DOMINICA","DO":"DOMINICAN REPUBLIC","DZ":"ALGERIA","EC":"ECUADOR","EE":"ESTONIA","EG":"EGYPT","EH":"WESTERN SAHARA","ER":"ERITREA","ES":"SPAIN","ET":"ETHIOPIA","FI":"FINLAND","FJ":"FIJI","FK":"FALKLAND ISLANDS (MALVINAS)","FM":"MICRONESIA (FEDERATED STATE)","FO":"FAROE ISLANDS","FR":"FRANCE","GA":"GABON","GB":"UNITED KINGDOM","GD":"GRENADA","GE":"GEORGIA","GF":"FRENCH GUIANA","GH":"GHANA","GI":"GIBRALTAR","GL":"GREENLAND","GM":"GAMBIA","GN":"GUINEA","GP":"GUADELOUPE","GQ":"EQUATORIAL GUINEA","GR":"GREECE","GS":"SOUTH GEORGIA & THE SOUTH SANDWICH ISLAN","GT":"GUATEMALA","GU":"GUAM","GW":"GUINEA-BISSAU","GY":"GUYANA","HK":"HONGKONG","HN":"HONDURAS","HR":"CROATIA (HRVATSKA)","HT":"HAITI","HU":"HUNGARY","ID":"INDONESIA","IE":"IRELAND","IL":"ISRAEL","IN":"INDIA","IO":"BRITISH INDIAN OCEAN TERRITORY","IQ":"IRAQ","IR":"IRAN (ISLAMIC REP.)","IS":"ICELAND","IT":"ITALY","JM":"JAMAICA","JO":"JORDAN","JP":"JAPAN","KE":"KENYA","KG":"KYRGYZSTAN","KH":"CAMBODIA","KI":"KIRIBATI","KM":"COMOROS","KN":"SAINT KITTS & NEVIS","KP":"KOREA (DEMOCRATIC PEOPLES REP.)","KR":"KOREA (REPUBLIC)","KW":"KUWAIT","KY":"CAYMAN ISLANDS","KZ":"KAZAKHSTAN","LA":"LAOS","LB":"LEBANON","LC":"SAINT LUCIA","LI":"LIECHTENSTEIN","LK":"SRI LANKA","LR":"LIBERIA","LS":"LESOTHO","LT":"LITHUANIA","LU":"LUXEMBOURG","LV":"LATVIA","LY":"LIBYAN ARAB JAMAHIRIYA","MA":"MOROCCO","MC":"MONACO","MD":"MOLDOVA (REP.)","ME":"MONTENEGRO","MG":"MADAGASCAR","MH":"MARSHALL ISLANDS","MK":"MACEDONIA","ML":"MALI","MM":"MYANMAR (BURMA)","MN":"MONGOLIA","MO":"MACAU","MP":"NORTHERN MARIANA ISLANDS","MQ":"MARTINIQUE","MR":"MAURITANIA","MS":"MONTSERRAT","MT":"MALTA","MU":"MAURITIUS","MV":"MALDIVES","MW":"MALAWI","MX":"MEXICO","MY":"MALAYSIA","MZ":"MOZAMBIQUE","NA":"NAMIBIA","NC":"NEW CALEDONIA","NE":"NIGER","NF":"NORFOLK ISLAND","NG":"NIGERIA","NI":"NICARAGUA","NL":"NETHERLANDS","NO":"NORWAY","NP":"NEPAL","NR":"NAURU","NU":"NIUE","NZ":"NEW ZEALAND","OM":"OMAN","PA":"PANAMA","PE":"PERU","PF":"FRENCH POLINESIA","PG":"PAPUA NEW GUINEA","PH":"PHILIPPINES","PK":"PAKISTAN","PL":"POLAND","PM":"SAINT PIERRE & MIQUELON","PN":"PITCAIRN","PR":"PUERTO RICO","PT":"PORTUGAL","PW":"PALAU","PY":"PARAGUAY","QA":"QATAR","RE":"REUNION","RO":"ROMANIA","RS":"SERBIA","RU":"RUSSIAN FEDERATION","RW":"RWANDA","SA":"SAUDI ARABIA","SB":"SOLOMON ISLANDS","SC":"SEYCHELLES","SD":"SUDAN","SE":"SWEDEN","SG":"SINGAPORE","SH":"SAINT HELENA","SI":"SLOVENIA","SJ":"SVALBARD & JAN MAYEN ISLANDS","SK":"SLOVAKIA (SLOVAK REP.)","SL":"SIERRA LEONE","SM":"SAN MARINO","SN":"SENEGAL","SO":"SOMALIA","SR":"SURINAME","SS":"SUDAN","ST":"SAO TOME & PRINCIPE","SV":"EL SALVADOR","SY":"SYRIAN ARAB (REP.)","SZ":"SWAZILAND","TC":"TURKS & CAICOS ISLANDS","TD":"CHAD","TG":"TOGO","TH":"THAILAND","TJ":"TAJIKISTAN","TK":"TOKELAU","TL":"EAST TIMOR","TM":"TURKMENISTAN","TN":"TUNISIA","TO":"TONGA","TR":"TURKEY","TT":"TRINIDAD & TOBAGO","TV":"TUVALU","TW":"TAIWAN","TZ":"TANZANIA (UNITED REP.)","UA":"UKRAINE","UG":"UGANDA","UM":"UNITED STATES MINOR OUTLYING ISLANDS","US":"UNITED STATES OF AMERICA","UY":"URUGUAY","UZ":"UZBEKISTAN","VA":"VATICAN CITY","VC":"SAINT VINCENT & GRENADINES","VE":"VENEZUELA","VG":"BRITISH VIRGIN ISLANDS","VI":"VIRGIN ISLANDS (U.S.)","VN":"VIET NAM","VU":"VANUATU","WF":"WALLIS & FUTUNA ISLANDS","WS":"SAMOA","YE":"YEMEN","YT":"FRANCE","ZA":"SOUTH AFRICA","ZM":"ZAMBIA","ZW":"ZIMBABWE","PS":"PALESTINE","YU":"YUGOSLAVIA","GZ":"GAZA STRIP","GG":"GUERNSEY","AN":"NETHERLANDS ANTILLES","CS":"SERBIA AND MONTENEGRO","AQ":"ANTARCTICA","BV":"BOUVET ISLAND","FA":"FAEROE ISLANDS","FX":"FRANCE, METROPOLITAN","TF":"FRENCH SOUTHERN TERRITORIES","HE":"HEARD","MI":"MICRONESIA","UN":"UNITED OF AMERICAN","UNM":"UNITED STATES MINOR","WA":"WALLIS AND FUTUNA","HA":"HAI PHAN QUOC TE","DA":"DANISH","TP":"EAST TIMOR","HM":"HEARD AND MC DONALD ISLANDS","IM":"ISLE OF MAN","JE":"JERSEY","WE":"WEST BANK","UE":"UNITED ARAB EMIRATES","KT":"ST KITTS AND NEVIS","HP":"HELLENIC REPUBLIC"},"status":{"ke_hoach":{"11":"Chờ tiếp nhận","12":"Đã tiếp nhận","13":"Từ chối tiếp nhận","14":"Chờ cấp KH điều động","15":"Đã cấp KH điều động","16":"Đã hủy KH điều động","27":"Yêu cầu sửa đổi bổ sung","114":"Chờ sửa KH điều động"},"thu_tuc":{"10":"Hủy thủ tục","12":"Chờ phê duyệt hoàn thành thủ tục","13":"Yêu cầu sửa đổi bổ sung","18":"Đã tiếp nhận","19":"Phê duyệt hoàn thành thủ tục","20":"Đề nghị cấp giấy phép","25":"Dừng thủ tục điện tử để làm giấy","120":"Đề nghị sửa giấy phép"}},"docType":{"4":"Tàu thuyền vào cảng","5":"Tàu thuyền rời cảng","8":"Nhập cảnh dầu khí","9":"Xuất cảnh dầu khí","10":"Vào cảng dầu khí","11":"Rời cảng dầu khí","12":"Chuyển cảng vào","13":"Chuyển cảng rời","14":"PTTNĐ VNCPC Nhập cảnh","15":"PTTNĐ VNCPC Xuất cảnh","16":"Nhập cảnh cảng TNĐ","17":"Xuất cảnh cảng TNĐ","NC":"Tàu thuyền nhập cảnh","XC":"Tàu thuyền xuất cảnh","QC":"Tàu thuyền quá cảnh"},"paymentMarkDeleteData":{"0":"","1":"","2":"","9":"","11":"báo nộp chuyển khoản","12":"thanh toán trực tuyến"},"paymentTypeData":{"0":"","1":"chuyển khoản","2":"trực tuyến"}}

/***/ })

},[653]);


// WEBPACK FOOTER //
// tra-cuu-public-theme/js/app.a230c2d545951bf40211.js